<template>
  <v-container max-width="100%" style="margin-top: 2%;">
    <ErroSistema v-bind="erro" ref="erroDialog" />
    <LoadingComponent :loading="loading" :message="loadingMessage" show-elapsed style="z-index: 1000;"></LoadingComponent>
    <ResultadoAxios ref="alertasAxios"></ResultadoAxios>

    <v-alert :type="this.tipoAlerta" timeout="5000" dismissible v-model="showAlert"
      style="margin-bottom: 35px; border-radius: 10px;">
      {{ this.mensagemAlerta }}
    </v-alert>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="closeConfirmDialog">{{ this.messageDismissButton
                }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="confirm">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="promoverDialog" persistent max-width="80%" style="border-radius: 10px">
          <v-card>
            <v-card-title style="color: #4a4a4a">{{ $t('candidate.candidateHiring') }}</v-card-title>
            <v-card-text>
              <v-form ref="formPromover" v-model="formPromoverValidado">
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <v-select v-model="situacaoSelected" :items="situacoes" item-text="nome" item-value="id_situacao"
                      :label="$t('candidate.jobOffer.situation')"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-select v-model="grupoSelected" :items="grupos" item-text="nome" item-value="id_grupo"
                      :label="$t('candidate.jobOffer.group')"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-select v-model="subgrupoSelected" :items="subgrupos" item-text="nome" item-value="id_grupo"
                      :label="$t('candidate.jobOffer.subgroup')" :disabled="isSubgrupoDisabled"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-select v-model="turnoSelected" :items="turnosPromoverFiltrados" item-text="descricao_turno" item-value="id_turno"
                      :label="$t('candidate.jobOffer.shift')"></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="promoverCandidatos()">{{ $t('button.actualize')
                }}</v-btn>
              <v-btn color="primary" class="white--text" @click="closePromoverDialog()">{{ $t('button.close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="unidadeValidadaDialog" persistent max-width="95%" style="border-radius: 10px">
          <v-card>
            <v-card-title style="color: #4a4a4a">{{ $t('candidate.selectValidatedUnitTitle') }}</v-card-title>
            <v-card-text>
              <p class="mb-3">{{ promoverAposUnidade ? $t('candidate.selectValidatedUnitPromoteHint') : $t('candidate.selectValidatedUnitTableHint') }}</p>
              <v-data-table
                :headers="unidadeValidadaHeaders"
                :items="unidadeValidadaItems"
                :items-per-page="-1"
                hide-default-footer
                dense
                class="elevation-2 unidade-validada-table"
                style="border-radius: 10px"
              >
                <template v-slot:item.nome="{ item }">
                  <div class="py-2">
                    <div class="font-weight-medium">{{ item.nome }}</div>
                    <div v-if="item.cpf" class="text-caption grey--text">{{ item.cpf }}</div>
                  </div>
                </template>
                <template v-slot:item.id_unidade="{ item }">
                  <v-autocomplete
                    v-model="item.id_unidade"
                    :items="item.unidades_disponiveis"
                    :item-text="unidadeSelectText"
                    item-value="id_unidade"
                    :label="$t('candidate.selectValidatedUnit')"
                    dense
                    outlined
                    hide-details
                    @change="onUnidadeValidadaUnitChange(item)"
                  />
                </template>
                <template v-slot:item.trajeto_ida="{ item }">
                  <div class="allocation-trip-card allocation-trip-card--ida">
                    <div class="allocation-trip-card__title">
                      <v-icon small color="primary">mdi-arrow-right</v-icon>
                      <span>{{ $t('guiasMotorista.directionIda') }}</span>
                    </div>
                    <v-autocomplete
                      v-model="item.id_linha_ida"
                      :items="linhasForUnidadeItem(item)"
                      :item-text="linhaLabel"
                      item-value="id_linha"
                      :label="$t('routePlanning.fields.selectLine')"
                      dense
                      outlined
                      hide-details
                      clearable
                      class="mb-2"
                      :disabled="item.id_unidade == null"
                      @change="onUnidadeValidadaLinhaChange(item, 'ida')"
                    />
                    <v-autocomplete
                      v-model="item.id_cerca_embarque"
                      :items="cercasForLinha(item.id_linha_ida)"
                      item-text="nome_cerca"
                      item-value="id_cerca"
                      :label="$t('passengers.personal.selectBoardingPoint')"
                      dense
                      outlined
                      hide-details
                      clearable
                      :disabled="item.id_linha_ida == null"
                    />
                  </div>
                </template>
                <template v-slot:item.trajeto_volta="{ item }">
                  <div class="allocation-trip-card allocation-trip-card--volta">
                    <div class="allocation-trip-card__title">
                      <v-icon small color="deep-purple">mdi-arrow-left</v-icon>
                      <span>{{ $t('guiasMotorista.directionVolta') }}</span>
                    </div>
                    <v-autocomplete
                      v-model="item.id_linha_volta"
                      :items="linhasForUnidadeItem(item)"
                      :item-text="linhaLabel"
                      item-value="id_linha"
                      :label="$t('routePlanning.fields.selectLine')"
                      dense
                      outlined
                      hide-details
                      clearable
                      class="mb-2"
                      :disabled="item.id_unidade == null"
                      @change="onUnidadeValidadaLinhaChange(item, 'volta')"
                    />
                    <v-autocomplete
                      v-model="item.id_cerca_desembarque"
                      :items="cercasForLinha(item.id_linha_volta)"
                      item-text="nome_cerca"
                      item-value="id_cerca"
                      :label="$t('passengers.personal.selectAlightingPoint')"
                      dense
                      outlined
                      hide-details
                      clearable
                      :disabled="item.id_linha_volta == null"
                    />
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" text :disabled="unidadeValidadaSaving"
                @click="skipUnidadeValidadaDialog">
                {{ $t('candidate.selectValidatedUnitSkip') }}
              </v-btn>
              <v-btn color="primary" class="white--text" :loading="unidadeValidadaSaving"
                :disabled="!canSaveUnidadeValidada"
                @click="confirmUnidadeValidadaTable">
                {{ $t('candidate.selectValidatedUnitSave') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="reservaDialog" persistent max-width="600px" style="border-radius: 10px">
          <v-card>
            <v-card-title style="color: #4a4a4a">{{ $t('candidateReservations.dialog.title') }}</v-card-title>
            <v-card-text>
              <div v-if="reservaCandidato" class="mb-3">
                <strong>{{ reservaCandidato.nome_completo || reservaCandidato.nome }}</strong>
              </div>
              <v-alert v-if="reservaAtiva" type="info" dense class="mb-3">
                {{ $t('candidateReservations.dialog.activeUntil', { date: formatReservaDate(reservaAtiva.dt_expiracao) }) }}
                <div class="mt-1">{{ reservaAtiva.nome_linha }} — {{ reservaAtiva.nome_cerca || '—' }}</div>
              </v-alert>
              <v-form v-if="!reservaAtiva" ref="formReserva" v-model="formReservaValidado">
                <v-select v-model="reservaLinhaSelected" :items="reservaLinhas" item-text="nome_linha"
                  item-value="id_linha" :label="$t('candidateReservations.dialog.line')" clearable
                  @change="onReservaLinhaChange" />
                <v-select v-model="reservaTurnoSelected" :items="reservaTurnosFiltrados" item-text="descricao_turno"
                  item-value="id_turno" :label="$t('candidateReservations.dialog.shift')" clearable />
                <v-select v-model="reservaCercaSelected" :items="reservaCercasFiltradas" item-text="nome_cerca"
                  item-value="id_cerca" :label="$t('candidateReservations.dialog.fence')" clearable />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="reservaAtiva" color="error" class="white--text" @click="cancelarReservaAtiva">
                {{ $t('candidateReservations.dialog.cancel') }}
              </v-btn>
              <v-btn v-if="!reservaAtiva" color="primary" class="white--text" :disabled="!canCreateReserva"
                @click="criarReserva">
                {{ $t('candidateReservations.dialog.reserve') }}
              </v-btn>
              <v-btn color="primary" class="white--text" @click="closeReservaDialog">{{ $t('button.close') }}</v-btn>
            </v-card-actions>
            <div v-if="reservaConfirmPending">
              <v-dialog v-model="confirmDialog" persistent max-width="500">
                <v-card>
                  <v-card-title class="headline">
                    <span style="color: #d60000">{{ $t('system.alert') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <span style="color: #d60000">{{ mensagemdialog }}</span>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="closeConfirmDialog">
                      {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="confirm">
                      {{ $t('button.confirm') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card>
        </v-dialog>
      </v-row>
    </template>


    <template>
      <v-row justify="center">
        <v-dialog v-model="uploadResultDialog" persistent max-width="80%" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #4a4a4a">{{ $t('system.labels.csvProcessResult') }}</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headersCSV" :items="resultCSV" sort-by="line_number" dense class="elevation-7"
                locale="pt" style="border-radius: 10px">
                <template v-slot:item.line_number="{ item }">
                  <CSVItem :value="item.line_number" :error="item.error_line" />
                </template>
                <template v-slot:item.cod_empresa="{ item }">
                  <CSVItem :value="item.cod_empresa" :error="item.error_empresa" />
                </template>
                <template v-slot:item.cod_cliente="{ item }">
                  <CSVItem :value="item.cod_cliente" :error="item.error_cliente" />
                </template>
                <template v-slot:item.cod_unidade="{ item }">
                  <CSVItem :value="item.cod_unidade" :error="item.error_unidade" />
                </template>
                <template v-slot:item.cpf="{ item }">
                  <CSVItem :value="item.cpf" :error="item.error_cpf" />
                </template>
                <template v-slot:item.nome="{ item }">
                  <CSVItem :value="item.nome" :error="item.error_nome" />
                </template>
                <template v-slot:item.sobrenome="{ item }">
                  <CSVItem :value="item.sobrenome" :error="item.error_sobrenome" />
                </template>
                <template v-slot:item.cep="{ item }">
                  <CSVItem :value="item.cep" :error="item.error_cep" />
                </template>
                <template v-slot:item.endereco="{ item }">
                  <CSVItem :value="item.endereco" :error="item.error_endereco" />
                </template>
                <template v-slot:item.numero="{ item }">
                  <CSVItem :value="item.numero" :error="item.error_numero" />
                </template>
                <template v-slot:item.complemento="{ item }">
                  <CSVItem :value="item.complemento" :error="item.error_complemento" />
                </template>
                <template v-slot:item.bairro="{ item }">
                  <CSVItem :value="item.bairro" :error="item.error_bairro" />
                </template>
                <template v-slot:item.cidade="{ item }">
                  <CSVItem :value="item.cidade" :error="item.error_cidade" />
                </template>
                <template v-slot:item.estado="{ item }">
                  <CSVItem :value="item.estado" :error="item.error_estado" />
                </template>
                <template v-slot:item.telefone="{ item }">
                  <CSVItem :value="item.telefone" :error="item.error_telefone" />
                </template>
                <template v-slot:item.email="{ item }">
                  <CSVItem :value="item.email" :error="item.error_email" />
                </template>
                <template v-slot:item.sexo="{ item }">
                  <CSVItem :value="item.sexo" :error="item.error_sexo" />
                </template>
                <template v-slot:item.pcd="{ item }">
                  <CSVItem :value="item.pcd" :error="item.error_pcd" />
                </template>
                <template v-slot:item.id_endereco_externo="{ item }">
                  <CSVItem :value="item.id_endereco_externo" :error="item.error_id_endereco_externo" />
                </template>
              </v-data-table>
              <v-subheader class="px-0 mt-4 primary--text font-weight-medium" style="height: auto;">
                {{ $t('candidate.csvUpload.externalAddressPreviewTitle') }}
              </v-subheader>
              <v-data-table
                :headers="headersCSVExternal"
                :items="resultCSV || []"
                sort-by="line_number"
                dense
                class="elevation-3"
                locale="pt"
                style="border-radius: 10px"
              >
                <template v-slot:item.line_number="{ item }">
                  <CSVItem :value="item.line_number" :error="item.error_line" />
                </template>
                <template v-slot:item.id_endereco_externo="{ item }">
                  <CSVItem :value="item.id_endereco_externo" :error="item.error_id_endereco_externo" />
                </template>
                <template v-slot:item.endereco="{ item }">
                  <CSVItem :value="item.endereco" :error="item.error_endereco" />
                </template>
                <template v-slot:item.numero="{ item }">
                  <CSVItem :value="item.numero" :error="item.error_numero" />
                </template>
                <template v-slot:item.complemento="{ item }">
                  <CSVItem :value="item.complemento" :error="item.error_complemento" />
                </template>
                <template v-slot:item.cep="{ item }">
                  <CSVItem :value="item.cep" :error="item.error_cep" />
                </template>
                <template v-slot:item.bairro="{ item }">
                  <CSVItem :value="item.bairro" :error="item.error_bairro" />
                </template>
                <template v-slot:item.cidade="{ item }">
                  <CSVItem :value="item.cidade" :error="item.error_cidade" />
                </template>
                <template v-slot:item.estado="{ item }">
                  <CSVItem :value="item.estado" :error="item.error_estado" />
                </template>
                <template v-slot:item.pais="{ item }">
                  <CSVItem :value="item.pais" :error="item.error_pais" />
                </template>
                <template v-slot:item.lat="{ item }">
                  <CSVItem :value="item.lat" :error="item.error_lat" />
                </template>
                <template v-slot:item.lng="{ item }">
                  <CSVItem :value="item.lng" :error="item.error_lng" />
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <strong :style="{ color: showSaveButton ? '#4a4a4a' : 'red' }">{{ this.mensagemUpload }}</strong>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-show="isProcessFinished" @click="downloadArquivoLog">{{ $t('button.downloadLog')
                }}</v-btn>
              <v-btn color="primary" class="white--text" @click="uploadResultDialog = false">{{ $t('button.cancel')
                }}</v-btn>
              <v-btn v-if="showSaveButton" color="primary" @click="saveBulk">{{ $t('button.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Cadastro e validação de endereços externos em massa (botão na barra da aba Endereços Externos). -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="importEnderecosDialog" persistent max-width="1100" style="border-radius: 10px;">
          <v-card>
            <v-card-title style="color: #4a4a4a">
              {{ $t('externalAddress.import.title') }}
            </v-card-title>
            <v-card-text>
              <p class="mb-3">{{ $t('externalAddress.import.hint') }}</p>

              <v-file-input
                v-model="importEnderecosArquivo"
                show-size
                accept="text/csv,text/plain,.csv"
                :label="$t('csv.upload.selectFileCsv')"
                :loading="importEnderecosLendo"
                @change="importEnderecosLerArquivo" />

              <v-alert v-if="importEnderecosErro" type="error" dense text class="mb-3">{{ importEnderecosErro }}</v-alert>

              <template v-if="importEnderecosLinhas.length">
                <div class="d-flex align-center flex-wrap mb-2">
                  <v-chip small label color="green darken-2" dark class="mr-2">
                    {{ $t('externalAddress.import.validRows', { count: importEnderecosValidas.length }) }}
                  </v-chip>
                  <v-chip v-if="importEnderecosComErro.length" small label color="red darken-2" dark>
                    {{ $t('externalAddress.import.invalidRows', { count: importEnderecosComErro.length }) }}
                  </v-chip>
                </div>
                <v-data-table
                  :headers="importEnderecosHeaders"
                  :items="importEnderecosLinhas"
                  item-key="line_number"
                  sort-by="line_number"
                  dense
                  class="elevation-3"
                  style="border-radius: 10px;">
                  <template v-slot:item.line_number="{ item }">
                    <CSVItem :value="item.line_number" :error="item.error_line" />
                  </template>
                  <template v-slot:item.id_endereco_externo="{ item }">
                    <CSVItem :value="item.id_endereco_externo" :error="item.error_id_endereco_externo" />
                  </template>
                  <template v-slot:item.agencia="{ item }">
                    <CSVItem :value="item.agencia" :error="item.error_agencia" />
                  </template>
                  <template v-slot:item.endereco="{ item }">
                    <CSVItem :value="item.endereco" :error="item.error_endereco" />
                  </template>
                  <template v-slot:item.lat="{ item }">
                    <CSVItem :value="item.lat" :error="item.error_lat" />
                  </template>
                  <template v-slot:item.lng="{ item }">
                    <CSVItem :value="item.lng" :error="item.error_lng" />
                  </template>
                </v-data-table>
                <p v-if="importEnderecosComErro.length" class="text-caption red--text text--darken-2 mt-2 mb-0">
                  {{ $t('externalAddress.import.invalidRowsSkipped') }}
                </p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="importEnderecosFechar">{{ $t('button.cancel') }}</v-btn>
              <v-btn color="primary" class="white--text" :disabled="importEnderecosValidas.length === 0" @click="importEnderecosConfirmar">
                {{ $t('externalAddress.import.confirm', { count: importEnderecosValidas.length }) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Navegação entre as seções, no mesmo padrão do drawer da Roteirização. -->
    <div class="candidatos-topbar">
      <v-btn
        icon
        class="candidatos-topbar__toggle"
        :aria-label="$t('candidate.nav.open')"
        @click="navDrawer = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <div class="candidatos-topbar__heading">
        <span class="candidatos-topbar__eyebrow">{{ $t('candidate.title') }}</span>
        <span class="candidatos-topbar__title">{{ activeModuleText }}</span>
      </div>
    </div>

    <v-navigation-drawer
      v-model="navDrawer"
      class="candidatos-nav-drawer"
      fixed
      temporary
      color="white"
      width="340"
    >
      <div class="candidatos-nav-header">
        <div class="candidatos-nav-brand-icon" aria-hidden="true">
          <v-icon color="grey darken-2">mdi-account-multiple-plus</v-icon>
        </div>
        <div class="candidatos-nav-heading">
          <span class="candidatos-nav-eyebrow">Merus</span>
          <span class="candidatos-nav-title">{{ $t('candidate.title') }}</span>
        </div>
        <v-btn
          icon
          class="candidatos-nav-close"
          :aria-label="$t('button.close')"
          @click="navDrawer = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-list class="candidatos-nav-list" nav>
        <v-list-item
          v-for="(module, i) in modules"
          :key="`CANDIDATOS-MODULE-${i}`"
          :class="{ 'candidatos-nav-item--active': mainTab === module.value }"
          :input-value="mainTab === module.value"
          color="grey darken-3"
          :aria-current="mainTab === module.value ? 'page' : null"
          class="candidatos-nav-item"
          @click="changeModule(module)"
        >
          <v-list-item-icon>
            <v-icon>{{ module.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="module.text" />
          </v-list-item-content>
          <v-list-item-icon v-if="mainTab === module.value" class="candidatos-nav-active-mark">
            <v-icon small color="grey darken-3">mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <div class="candidatos-split">
      <div class="candidatos-split__main">

        <v-container v-show="mainTab === 2" class="toolbar__container" style="margin-bottom: 0;">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="filtroUnidadeSelected"
                :items="unidades"
                item-text="cod_unidade"
                item-value="id_unidade"
                :label="$tc('unit.self', 2)"
                multiple
                chips
                deletable-chips
                small-chips
                clearable
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleAllUnidadesFiltro">
                    <v-list-item-action>
                      <v-icon :color="filtroUnidadeSelected.length > 0 ? 'indigo darken-4' : ''">
                        {{ selectIconUnidadesFiltro }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('operation.all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="filtroTurnosSelected"
                :items="turnosParaFiltroColunas"
                item-text="descricao_turno"
                item-value="id_turno"
                :label="$t('candidate.jobOffer.shift')"
                multiple
                chips
                deletable-chips
                small-chips
                clearable
              />
            </v-col>
          </v-row>
          <v-row v-if="filtroIdsCandidatos" dense>
            <v-col cols="12">
              <v-chip small close color="primary" outlined @click:close="limparFiltroIdsCandidatos">
                <v-icon x-small left>mdi-check-all</v-icon>
                {{ $t('relExternalAddressKpis.selection.fromReport', { count: filtroIdsCandidatos.split(',').length }) }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row v-if="filtroPoligonoCandidatos" dense>
            <v-col cols="12">
              <v-chip small close color="primary" outlined @click:close="limparPoligonoCandidatos">
                <v-icon x-small left>mdi-vector-polygon</v-icon>
                {{ $t('candidate.map.areaFilter') }}
              </v-chip>
            </v-col>
          </v-row>
          <KpisEnderecosOrigemPainel origem="C" :ativa="mainTab === 2" :turnos="kpiTurnosVisiveis" />
        </v-container>

        <merus-data-table v-show="mainTab === 2" :headers="headers" :items="candidatos" :mostrar-inativos="mostrarInativos" :loading="loadingtable"
          :extra-headers="turnoColumnHeaders"
          :suppress-header-values="allTurnoHeaderValues"
          :default-multi-sort="defaultSort"
          :loading-text="validacaoLoadingText"
          :show-select="true"
          item-key="id_pessoa"
          v-model="candidatosSelected"
          :server-items-length="totalCandidatos"
          :items-per-page="numberOfRows"
          :items-per-page-last-option="itemsPerPageLastOption"
          :server-sort-by="serverSortBy"
          :server-sort-desc="serverSortDesc"

          fixed-header
          @update:options="onTableOptions"
          @update:filters="onFiltersUpdate"
          style="border-radius: 10px; margin-top: 0px; margin-bottom: 20px;"
     cod-tabela="CANDIDATOS" @update:headers="headers = $event">
          <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('candidate.title')"
              :token="token"
              :items="candidatos"
              :load-items-for-export="loadItemsForExport"
              background-export
              list-endpoint="getallcandidatos"
              :export-filters="searchFilters"
              :export-sort-by="serverSortBy"
              :export-sort-desc="serverSortDesc"
              :export-total="totalCandidatos"
              :selected-ids="selectedCandidatosIds"
              id-field="id_pessoa"
              :csv-title="$t('candidate.title')"
              :csv-headers="headersCsvExport"
              :pdf-title="$t('candidate.pdfTitle')"
              :pdf-headers="headers"
              pdf-filename="candidatos"
              hide-search>
              <template v-slot:extension>
                <v-switch
                  v-model="mostrarInativos"
                  :label="$t('crudVeiculos.showInactive')"
                  class="ml-3 mr-4"
                  hide-details
                ></v-switch>
              </template>
              <template v-slot:add>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <HelpDialogCSV
                      v-on="on"
                      :fields="helpCSV"
                      :model="$tc('candidate.self', 2)"
                      :data="csvExportData"
                      :data-loader="loadItemsForExport"
                      :local-row-limit="csvLocalRowLimit"
                      list-endpoint="getallcandidatos"
                      :export-filters="searchFilters"
                      :export-sort-by="serverSortBy"
                      :export-sort-desc="serverSortDesc"
                      :export-total="totalCandidatos"
                      :selected-ids="selectedCandidatosIds"
                      id-field="id_pessoa"
                      size="s"
                    ></HelpDialogCSV>
                  </template>
                  <span>{{ $t('helpCard.defaultTitle') }}</span>
                </v-tooltip>

                <UploadDialog
                  :token="token || ''"
                  endpoint="/api/v1.0/processacsvcandidatos/"
                  size="s"
                  @done="onCsvUploadDone"
                />

                <v-menu offset-y :close-on-content-click="false" min-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: onTooltip }">
                        <v-btn
                          color="#4a4a4a"
                          dark
                          small
                          class="mb-2 mr-2"
                          fab
                          v-bind="attrs"
                          v-on="{ ...onTooltip, ...on }">
                          <v-icon>mdi-tune-variant</v-icon>
                        </v-btn>
                      </template>
                      <div>{{ $t('candidate.validationOptions.title') }}</div>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title class="text-subtitle-2 py-2">
                      {{ $t('candidate.validationOptions.title') }}
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="py-2">
                      <v-switch
                        v-model="validacaoCheckCapacity"
                        dense
                        hide-details
                        class="mt-0"
                        :label="$t('candidate.validationOptions.checkCapacity')" />
                      <v-switch
                        v-model="validacaoConsiderarReservas"
                        dense
                        hide-details
                        class="mt-0"
                        :label="$t('candidate.validationOptions.considerReservations')" />
                      <v-switch
                        v-model="validacaoCalcularCaminhada"
                        dense
                        hide-details
                        class="mt-0"
                        :label="$t('candidate.validationOptions.walkDistance')" />
                      <v-switch
                        v-model="validacaoConsiderarTempoPermanencia"
                        dense
                        hide-details
                        class="mt-0"
                        :label="$t('candidate.validationOptions.considerRideTime')" />
                      <v-text-field
                        v-model="validacaoTempoMaximoPermanencia"
                        :disabled="!validacaoConsiderarTempoPermanencia"
                        type="number"
                        min="1"
                        suffix="min"
                        dense
                        clearable
                        class="mt-3"
                        :label="$t('candidate.validationOptions.maxRideTime')"
                        :hint="$t('candidate.validationOptions.maxRideTimeHint')"
                        persistent-hint />
                      <v-text-field
                        v-model="validacaoMaxLinhasRetorno"
                        type="number"
                        min="1"
                        :max="maxLinhasRetornoLimite"
                        dense
                        clearable
                        class="mt-3"
                        :label="$t('candidate.validationOptions.maxLines')"
                        :hint="$t('candidate.validationOptions.maxLinesHint', { padrao: maxLinhasRetornoPadrao, maximo: maxLinhasRetornoLimite })"
                        persistent-hint />
                    </v-card-text>
                  </v-card>
                </v-menu>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" fab v-on="on"
                      @click="atualizaRotasCandidatos([...candidatosSelected])">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <div>{{ $t('candidate.validateSelected') }}</div>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" fab v-on="on" :loading="promoverLoading" @click="openPromoverDialog">
                      <v-icon>mdi-account-arrow-up</v-icon>
                    </v-btn>
                  </template>
                  <div>{{ $t('candidate.promoteSelected') }}</div>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" fab v-on="on" @click="openReservaDialog">
                      <v-icon>mdi-seat-passenger</v-icon>
                    </v-btn>
                  </template>
                  <div>{{ $t('candidate.reserveSeat') }}</div>
                </v-tooltip>

              <v-dialog v-model="dialog" max-width="100%" fullscreen>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#4a4a4a" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-btn icon dark @click="close">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <template v-slot:extension>
                      <v-tabs v-model="tab" align-with-title>
                        <v-tab v-for="item in tabs" :key="item.text" v-show="!item.disabled">
                          {{ item.text }}
                        </v-tab>
                      </v-tabs>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                      </v-toolbar-items>
                    </template>
                  </v-toolbar>

                  <v-card-text>
                    <v-container v-show="tab === 0">
                      <v-alert
                        v-if="origemProgredida"
                        type="info"
                        dense
                        outlined
                        class="mb-2">
                        {{ origemProgredida }}
                        <div v-if="editedIndex === -1 && situacaoProgredidaNome" class="mt-1 font-weight-medium">
                          {{ $t('candidate.progressionSituation', { situacao: situacaoProgredidaNome }) }}
                        </div>
                        <div v-else-if="editedIndex === -1" class="mt-1">
                          {{ $t('candidate.progressionNoSituation') }}
                        </div>
                        <div class="mt-1">
                          {{ promocaoBloqueiaNome
                            ? $t('candidate.progressionLockedNameAndAddress')
                            : $t('candidate.progressionLockedAddress') }}
                        </div>
                      </v-alert>
                      <v-form ref="formPessoal" v-model="formPessoalValidado">
                        <v-row>
                          <v-col cols="12" sm="4" md="4">
                            <v-text-field v-model="editedItem.nome" :label="$t('person.name')"
                              :readonly="campoTravadoPorPromocao('nome')" :rules="[
                              (v) => !!v || $t('candidate.nameRequired')]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-text-field v-model="editedItem.sobrenome" :label="$t('person.familyName')"
                              :readonly="campoTravadoPorPromocao('sobrenome')" :rules="[
                              (v) => !!v || $t('candidate.familyNameRequired')]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-text-field v-model="editedItem.cpf" :label="labelDocumentoIdentidade" :rules="[validaDocumentoIdentidade]"
                              @change="cpfChanged"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="editedItem.telefone" :label="$t('person.telephone')"
                              type="phone"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.email" :label="$t('person.email')"
                              type="email"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="3">
                            <v-autocomplete
                              v-model="editedItem.id_agencia_emprego"
                              :items="agenciasAtivas"
                              :item-text="agenciaItemText"
                              item-value="id_agencia_emprego"
                              :label="$t('ticketSolicitacaoCandidatos.fields.agencia')"
                              clearable
                            />
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12" md="2">
                            <v-checkbox v-model="pcd" prepend-icon="mdi-wheelchair"
                              :label="$t('system.labels.PCD')" hide-details="auto"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="12" md="2">
                            <v-select v-model="editedItem.sexo" :items="sexo" item-text="text" item-value="value" auto
                              :label="$t('person.gender')"></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <v-select v-model="editedItem.id_cliente" :items="clientes" item-text="nome_cliente"
                              item-value="id_cliente" auto :label="$tc('client.self', 1)" clearable
                              :disabled="isClienteSelectDisabled"></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <LazySelect
                              v-if="!usaUnidadesValidadasRestritas"
                              ref="unidadeSelect"
                              get-url="getUnidadeslazy"
                              :text="unidadeSelectText"
                              value="id_unidade"
                              :label="$tc('unit.self', 1)"
                              @input="onUnidadeSelect"
                            />
                            <v-select
                              v-else
                              v-model="editedItem.id_unidade"
                              :items="unidadesParaEdicao"
                              :item-text="unidadeSelectText"
                              item-value="id_unidade"
                              auto
                              :label="$tc('unit.self', 1)"
                              clearable
                              :hint="unidadesValidadasHint"
                              :persistent-hint="!!unidadesValidadasHint"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>

                    <v-container v-show="tab === 1">
                      <v-form ref="formEndereco" v-model="formEnderecoValidado">
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-select v-model="editedItem.id_pais" :loading=loadingtext :disabled="campoTravadoPorPromocao('id_pais')"
                              :label="$t('passengers.address.country')" :items="paises" item-text="nome" item-value="id_pais"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.cep" :label="$t('address.postalCode')" :rules="[validaCEP]"
                              @blur="consultaCEP" :loading=loadingtext :readonly="campoTravadoPorPromocao('cep')"
                              :placeholder="$t('passengers.address.cepPlaceholder')"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="2" md="2">
                            <v-text-field v-model="editedItem.estado" :loading=loadingtext :label="$t('address.state')"
                              :readonly="campoTravadoPorPromocao('estado')" filled></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="5" md="5">
                            <v-text-field v-model="editedItem.cidade" :loading=loadingtext :label="$t('address.city')"
                              :readonly="campoTravadoPorPromocao('cidade')" filled></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="5" md="5">
                            <v-text-field v-model="editedItem.bairro" :loading=loadingtext :label="$t('address.district')"
                              :readonly="campoTravadoPorPromocao('bairro')" filled></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedItem.endereco" :loading=loadingtext :label="$t('address.street')"
                              :readonly="campoTravadoPorPromocao('endereco')" filled></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="3" md="3">
                            <v-text-field v-model="editedItem.numero" :label="$t('address.number')"
                              :readonly="campoTravadoPorPromocao('numero')" :rules="[
                              (v) => !!v || $t('address.numberRequired')]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="9" md="9">
                            <v-text-field v-model="editedItem.complemento" :label="$t('address.complement')"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>

                    <div v-show="tab === 2">
                      <v-container>
                        <v-form ref="formSituacoes" v-model="formSituacoesValidado">
                          <v-row>
                            <v-col cols="12" sm="12" md="2">
                              <v-select v-model="novaSituacao" :label="$tc('situation.self', 1)" :items="situacoes"
                                item-text="nome" return-object></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                              <v-datetime-picker :label="$t('datetime.startValidity')" v-model="dtInicioVigenciaSituacao"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps"
                                :time-format="$t('datetime.timeFormat')" :date-format="$t('datetime.dateFormat')"
                                :clear-text="$t('button.close')">
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="10" md="4">
                              <v-datetime-picker :label="$t('datetime.endValidity')" v-model="dtFimVigenciaSituacao"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps"
                                :time-format="$t('datetime.timeFormat')" :date-format="$t('datetime.dateFormat')"
                                :clear-text="$t('button.close')">
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <v-btn color="primary" dark small class="mb-2" fab :disabled="disableInsertSituacoes"
                                @click="saveSituacao">
                                <v-icon>{{ editingSituacao ? 'mdi-check' : 'mdi-plus' }}</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                      <v-data-table :headers="headersSituacoes" :items="situacoesUsuario" :search="search"
                        :loading="loadingtable" :sort-by="['ativa', 'dt_inicio_vigencia']" :sort-desc="[true, true]" dense
                        class="elevation-7" locale="pt" style="border-radius: 10px;">
                        <template v-slot:top>
                          <v-toolbar flat color="white" style="border-radius: 10px">
                            <v-toolbar-title style="color: #4a4a4a">{{ $tc('situation.self', 2) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="searchSituacoes" append-icon="mdi-magnify" :label="$t('system.search')"
                              single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>

                        <template v-slot:item.actions="{ item, index }">
                          <v-icon small class="mr-2" color="green" @click="editSituacao(item, index)"
                            :disabled="item.can_edit == 0">mdi-pencil</v-icon>

                          <v-icon small class="mr-2" color="red" @click="deleteSituacao(item, index)"
                            :disabled="item.can_delete == 0">mdi-delete</v-icon>
                        </template>
                      </v-data-table>
                    </div>
                    <div v-show="tab === 3">
                      <v-container>
                        <v-form ref="formSituacoesValidacao" v-model="formSituacoesValidacaoValidado">
                          <v-row>
                            <v-col cols="12" sm="12" md="2">
                              <v-select v-model="novaSituacaoValidacao" :label="$tc('validationSituation.self', 1)" :items="situacoesValidacao"
                                item-text="nome" return-object></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                              <v-datetime-picker :label="$t('datetime.startValidity')" v-model="dtInicioVigenciaSituacaoValidacao"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps"
                                :time-format="$t('datetime.timeFormat')" :date-format="$t('datetime.dateFormat')"
                                :clear-text="$t('button.close')">
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="10" md="4">
                              <v-datetime-picker :label="$t('datetime.endValidity')" v-model="dtFimVigenciaSituacaoValidacao"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps"
                                :time-format="$t('datetime.timeFormat')" :date-format="$t('datetime.dateFormat')"
                                :clear-text="$t('button.close')">
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <v-btn color="primary" dark small class="mb-2" fab :disabled="disableInsertSituacoesValidacao"
                                @click="saveSituacaoValidacao">
                                <v-icon>{{ editingSituacaoValidacao ? 'mdi-check' : 'mdi-plus' }}</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                      <v-data-table :headers="headersSituacoesValidacao" :items="situacoesValidacaoUsuario" :search="search"
                        :loading="loadingtable" :sort-by="['ativa', 'dt_inicio_vigencia']" :sort-desc="[true, true]" dense
                        class="elevation-7" locale="pt" style="border-radius: 10px;">
                        <template v-slot:top>
                          <v-toolbar flat color="white" style="border-radius: 10px">
                            <v-toolbar-title style="color: #4a4a4a">{{ $tc('validationSituation.self', 2) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="searchSituacoesValidacao" append-icon="mdi-magnify" :label="$t('system.search')"
                              single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>

                        <template v-slot:item.actions="{ item, index }">
                          <v-icon small class="mr-2" color="green" @click="editSituacaoValidacao(item, index)"
                            :disabled="item.can_edit == 0">mdi-pencil</v-icon>

                          <v-icon small class="mr-2" color="red" @click="deleteSituacaoValidacao(item, index)"
                            :disabled="item.can_delete == 0">mdi-delete</v-icon>
                        </template>
                      </v-data-table>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
              </template>
            </CadastroToolbar>
          </template>

          <template v-slot:item.nome_completo="{ item }">
            {{ getNomeCompletoFormatado(item.nome_completo) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>

            <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>

            <v-icon small class="mr-2" color="blue" @click="atualizaRotasCandidatos([item])">mdi-check</v-icon>

            <v-icon small class="mr-2" color="orange" @click="showErrosDialog(item)"
              v-if="item.tem_erros_envio == 1">mdi-alert</v-icon>
          </template>
        </merus-data-table>

        <EnderecosExternosTab
          ref="enderecosExternosTab"
          v-show="mainTab === 0"
          :ativa="mainTab === 0"
          :token="token"
          :turnos="turnos"
          :agencias="agencias"
          :paises="paises"
          :selecao-inicial="selecaoEnderecos"
          @selecao-aplicada="selecaoEnderecos = null"
          @progredir="progredirEnderecoParaCandidato"
          :filtro-poligono="filtroPoligonoEnderecos"
          @update:selecao="enderecosMapSelection = $event"
          @area-aplicada="avisarAreaAplicada"
          @limpar-poligono="filtroPoligonoEnderecos = ''">
          <template v-slot:toolbar-acoes="{ carregando }">
            <HelpDialogCSV
              :fields="helpCsvEnderecosExternos"
              :model="$t('externalAddress.title')"
              :intro-text="$t('externalAddress.import.helpIntro', { length: helpCsvEnderecosExternos.length })"
              :data-loader="carregaEnderecosParaCsv"
              :local-row-limit="csvLocalRowLimit"
              size="s" />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" small class="mb-2 mr-2" fab :disabled="carregando" v-on="on"
                  @click="importEnderecosDialog = true">
                  <v-icon>mdi-file-upload</v-icon>
                </v-btn>
              </template>
              <div>{{ $t('externalAddress.import.button') }}</div>
            </v-tooltip>
          </template>
        </EnderecosExternosTab>

        <PreCandidatosTab
          v-show="mainTab === 1"
          :ativa="mainTab === 1"
          :token="token"
          :agencias="agencias"
          :turnos="turnos"
          :situacoes="situacoesValidacao"
          :selecao-inicial="selecaoPreCandidatos"
          @selecao-aplicada="selecaoPreCandidatos = null"
          @progredir="progredirPreCandidatoParaCandidato"
          :filtro-poligono="filtroPoligonoPreCandidatos"
          @update:selecao="preCandidatosMapSelection = $event"
          @area-aplicada="avisarAreaAplicada"
          @limpar-poligono="filtroPoligonoPreCandidatos = ''" />
      </div>

      <div class="candidatos-split__side">
        <v-card class="elevation-3 candidatos-map-card" style="border-radius: 10px;">
          <v-card-title class="subtitle-1 py-3" style="color: #4a4a4a;">
            {{ mapSectionTitle }}
            <v-spacer></v-spacer>
            <v-btn
              small
              color="primary"
              class="ml-2"
              :loading="loadingMapGeocode"
              :disabled="loadingMapGeocode || mapRows.length === 0"
              @click="refreshCandidateMapPositions"
            >
              <v-icon left small>mdi-map-marker-path</v-icon>
              {{ $t('candidate.map.refreshGeocodes') }}
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-0 candidatos-map-card__body">
            <div class="d-flex flex-wrap align-center mb-3" style="gap: 10px;">
              <span class="text-caption font-weight-medium">{{ $t('candidate.map.legend') }}</span>
              <div
                v-for="(leg, i) in mapLegendEntries"
                :key="'cand-map-leg-' + i"
                class="d-flex align-center"
                style="gap: 6px;"
              >
                <span
                  class="candidatos-map-legend-dot"
                  :style="{ backgroundColor: leg.color }"
                ></span>
                <span class="text-caption">{{ leg.label }}</span>
              </div>
            </div>
            <div class="d-flex flex-wrap align-center mb-3" style="gap: 8px;">
              <v-btn small :color="areaDesenho.ativo ? 'warning' : 'primary'" outlined @click="alternarDesenhoArea">
                <v-icon left small>mdi-vector-polygon</v-icon>
                {{ areaDesenho.ativo ? $t('candidate.map.areaCancel') : $t('candidate.map.areaDraw') }}
              </v-btn>
              <template v-if="areaDesenho.ativo">
                <v-btn small outlined :disabled="!areaDesenho.vertices.length" @click="desfazerVerticeArea">
                  <v-icon left small>mdi-undo</v-icon>
                  {{ $t('candidate.map.areaUndo') }}
                </v-btn>
                <v-btn small color="success" :disabled="!areaPodeConcluir" @click="concluirDesenhoArea">
                  <v-icon left small>mdi-check</v-icon>
                  {{ $t('candidate.map.areaFinish') }}
                </v-btn>
              </template>
              <v-btn v-if="(areaDesenho.poligono || filtroAtivoNaAba) && !areaDesenho.ativo" small text @click="limparAreaCompleta">
                <v-icon left small>mdi-close</v-icon>
                {{ $t('candidate.map.areaClear') }}
              </v-btn>
            </div>
            <div class="candidatos-map-container">
              <l-map
                ref="candidatosMap"
                :zoom="mapZoom"
                :center="mapCenter"
                class="candidatos-map"
                :options="{ preferCanvas: true }"
                @ready="onCandidatosMapReady"
              >
                <l-tile-layer :url="mapTileUrl" :attribution="mapAttribution"></l-tile-layer>
              </l-map>
            </div>
            <p class="text-caption mt-2 mb-0" style="color: #666;">
              {{ $t('candidate.map.hint') }}
              <span class="ml-1">{{ mapPlottedCount }} / {{ mapRows.length }} {{ $t('candidate.map.withCoordinates') }}.</span>
            </p>
            <p v-if="mapRows.length === 0" class="text-caption mt-1 mb-0" style="color: #888;">
              {{ $t('candidate.map.selectRowsHint') }}
            </p>
          </v-card-text>
        </v-card>
      </div>
    </div>

  </v-container>
</template>

<script>

import axios from "axios";
import apiController from "@/utils/apiController";
import { isValidado } from '@/utils/situacoesValidacao';
import L from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { defaultCountry } from "@/constants";
import ErroSistema from "./Notifications/ErroSistema.vue";
import DateUtils from "../utils/dateutils";
import LoadingComponent from "./LoadingComponent.vue";
import CSVItem from "./CSVItem.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import HelpDialogCSV from "./Dialogs/HelpDialogCSV.vue";
import UploadDialog from "./Dialogs/UploadDialog.vue";
import ResultadoAxios from "./Notifications/ResultadoAxios.vue";
import EventBus from "@/utils/eventBus";
import registrarChamadaApiExterna from "@/utils/registrarChamadaApiExterna";
import curp from "curp";
import translateDbField from "@/utils/translateDbField";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import LazySelect from "./Selects/LazySelect.vue";
import EnderecosExternosTab from "./Enderecos/EnderecosExternosTab.vue";
import PreCandidatosTab from "./PreCandidatos/PreCandidatosTab.vue";
import KpisEnderecosOrigemPainel from "./Enderecos/KpisEnderecosOrigemPainel.vue";
import serverTableMixin from "@/mixins/serverTableMixin";
import { ABA_POR_ORIGEM, consumirSelecaoRevalidacao } from "@/utils/revalidacaoSelecao";
import validacaoSchedulerMixin from "@/mixins/validacaoSchedulerMixin";
import desenhoAreaMapaMixin from "@/mixins/desenhoAreaMapaMixin";
import { MAP_VALIDATION_COLOR, mapMarkerPriorityRank, mapColorForValidoCode } from "@/utils/mapIcons";
import { buildRequestParams, computePageState, initSortFromDefault, fetchAllServerPagesForExport } from "@/utils/serverTablePagination";

const RESERVA_DIAS = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

/** Colunas do CSV de cadastro em massa de endereços externos, na ordem do modelo do helper. */
const COLUNAS_CSV_ENDERECOS = [
  'id_endereco_externo',
  'agencia',
  'cep',
  'endereco',
  'numero',
  'bairro',
  'cidade',
  'estado',
  'pais',
  'lat',
  'lng',
];

/** Nomes alternativos aceitos no cabeçalho (comparados sem acento e em minúsculas). */
const APELIDOS_CSV_ENDERECOS = {
  id_externo: 'id_endereco_externo',
  idexternal: 'id_endereco_externo',
  id_external: 'id_endereco_externo',
  codigo: 'id_endereco_externo',
  agencia_emprego: 'agencia',
  rua: 'endereco',
  logradouro: 'endereco',
  uf: 'estado',
  latitude: 'lat',
  longitude: 'lng',
  lon: 'lng',
};

function normalizarCabecalhoCsv(texto) {
  const chave = String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  return APELIDOS_CSV_ENDERECOS[chave] || chave;
}

/** Separa as células respeitando aspas ("a;b" fica numa célula só). */
function quebrarCsv(texto, sep) {
  const linhas = [];
  let linha = [];
  let celula = '';
  let entreAspas = false;
  for (let i = 0; i < texto.length; i++) {
    const c = texto[i];
    if (entreAspas) {
      if (c === '"' && texto[i + 1] === '"') {
        celula += '"';
        i++;
      } else if (c === '"') {
        entreAspas = false;
      } else {
        celula += c;
      }
    } else if (c === '"') {
      entreAspas = true;
    } else if (c === sep) {
      linha.push(celula);
      celula = '';
    } else if (c === '\n') {
      linha.push(celula);
      linhas.push(linha);
      linha = [];
      celula = '';
    } else if (c !== '\r') {
      celula += c;
    }
  }
  linha.push(celula);
  linhas.push(linha);
  return linhas.filter((l) => l.some((v) => String(v).trim() !== ''));
}

function lerComoTexto(arquivo, encoding) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(arquivo, encoding);
  });
}

function numeroOuNull(v) {
  if (v == null || String(v).trim() === '') return null;
  const n = Number(String(v).trim().replace(',', '.'));
  return Number.isFinite(n) ? n : NaN;
}

export default {
  components: {
    ErroSistema,
    LoadingComponent,
    CSVItem,
    CadastroToolbar,
    HelpDialogCSV,
    UploadDialog,
    ResultadoAxios,
    LMap,
    LTileLayer,
    MerusDataTable,
    LazySelect,
    EnderecosExternosTab,
    PreCandidatosTab,
    KpisEnderecosOrigemPainel,
  },
  mixins: [serverTableMixin, validacaoSchedulerMixin, desenhoAreaMapaMixin],
  data: () => ({
    headers: [],
    search: "",
    erro: null,
    errosDialog: false,
    loadingErrosEnvio: false,
    // Começa em `false` porque a lista de candidatos não é mais buscada na entrada da
    // tela: deixar `true` mantinha o indicador de carregamento aceso indefinidamente,
    // já que só `serverTableLoad` o desliga. Ele sobe quando a seção é aberta e a busca
    // realmente começa.
    loadingtable: false,
    loadingtext: false,
    loadingSave: false,
    loadingSaveFotos: false,
    loadingSaveSituacoes: false,
    loadingSaveSituacoesValidacao: false,
    loadingDeleteFotos: false,
    loadingAtualizacaoFaceid: false,
    searchSituacoes: "",
    searchSituacoesValidacao: "",
    disableInsertSituacoes: false,
    disableInsertSituacoesValidacao: false,
    formValidadoSituacoes: true,
    showConfirmButton: true,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    dialog: false,
    dialogSituacoes: false,
    promoverDialog: false,
    unidadeValidadaDialog: false,
    unidadeValidadaItems: [],
    // Diálogo de unidade/linha aberto pelo botão Promover: ao associar ou pular, segue para o
    // diálogo de promoção.
    promoverAposUnidade: false,
    promoverLoading: false,
    unidadeValidadaFencesByLine: {},
    unidadeValidadaSaving: false,
    editedItemUnidadesValidadas: [],
    reservaDialog: false,
    reservaCandidato: null,
    reservaAtiva: null,
    reservaLinhas: [],
    reservaLinhaSelected: null,
    reservaTurnoSelected: null,
    reservaCercaSelected: null,
    reservaCercas: [],
    _reservaPrefilling: false,
    reservaConfirmPending: false,
    // Capacidade, caminhada e tempo de permanência são opt-in, como no endpoint.
    validacaoCheckCapacity: false,
    validacaoConsiderarReservas: true,
    // Desligado, a validação fica na distância em linha reta (sem o planejador de rotas a pé).
    validacaoCalcularCaminhada: false,
    // Desligado, o tempo a bordo só é exibido: nenhuma linha é reprovada por ele.
    validacaoConsiderarTempoPermanencia: false,
    // Override manual do limite de permanência na linha; vazio herda linha/unidade/config.
    validacaoTempoMaximoPermanencia: null,
    // Quantas linhas a validação devolve por pessoa; vazio usa o padrão da API.
    validacaoMaxLinhasRetorno: null,
    maxLinhasRetornoLimite: 20,
    formReservaValidado: false,
    formPromoverValidado: false,
    menu2: false,
    menu: false,
    operacao: 0,
    isIdClienteDisabled: false,
    isPerfilDisabled: false,
    confirmDialog: false,
    mensagemdialog: "",
    disableLogin: false,
    isGrupoDisabled: false,
    show1: false,
    show2: false,
    qrcodeDialog: false,
    uploadResultDialog: false,
    importEnderecosDialog: false,
    importEnderecosArquivo: null,
    importEnderecosLendo: false,
    importEnderecosErro: null,
    importEnderecosLinhas: [],
    showSaveButton: false,
    tab: 0,
    /**
     * Aba do topo da tela. Quem manda na ordem é o template: cada bloco usa o seu
     * próprio `mainTab === N`, e a aba de endereços externos recebe isso via :ativa,
     * então trocar as abas de lugar não exige mexer no script.
     */
    mainTab: 0,
    /**
     * A lista de candidatos só é buscada quando a seção "Candidatos" é aberta pela
     * primeira vez — as outras seções (endereços externos, pré-candidatos) já fazem o
     * mesmo pelo próprio `ativa`, e a tela abre em outra seção, então carregar a lista
     * no `initialize()` gastava uma requisição pesada que ninguém tinha pedido ainda.
     */
    candidatosCarregados: false,
    /** Seleção vinda do relatório de KPIs (utils/revalidacaoSelecao): cada aba recebe a sua. */
    selecaoEnderecos: null,
    selecaoPreCandidatos: null,
    selecaoCandidatos: null,
    /** Ids (separados por vírgula) a que a lista de candidatos fica restrita; vazio = todos. */
    filtroIdsCandidatos: '',
    candidatos: [],
    candidatosSelected: [],
    empresas: [],
    totalCandidatos: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    mostrarInativos: false,
    situacoes: [],
    situacoesUsuario: [],
    situacoesValidacao: [],
    situacoesValidacaoUsuario: [],
    clientes: [],
    perfis: [],
    turnos: [],
    turnoSelected: null,
    unidades: [],
    filtroUnidadeSelected: [],
    previousFiltroUnidadeSelected: [],
    filtroTurnosSelected: [],
    agencias: [],
    grupos: [],
    subgrupos: [],
    grupoSelected: null,
    subgrupoSelected: null,
    situacaoSelected: null,
    resultCSV: null,
    editedIndex: -1,
    editedItem: {
      id_pessoa: null,
      nome: null,
      sobrenome: null,
      id_cliente: null,
      cpf: null,
      cep: null,
      id_endereco: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      sexo: null,
      telefone: null,
      email: null,
      id_unidade: null,
      id_agencia_emprego: null,
      contratado: null,
    },
    deletedItem: {
      id_pessoa: null,
      nome: null,
      sobrenome: null,
      id_cliente: null,
      cpf: null,
      id_endereco: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      sexo: null,
      telefone: null,
      email: null,
      id_unidade: null,
      id_agencia_emprego: null,
      contratado: null,
    },
    defaultItem: {
      id_pessoa: null,
      nome: null,
      sobrenome: null,
      id_cliente: null,
      cpf: null,
      id_endereco: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      sexo: null,
      telefone: null,
      email: null,
      id_unidade: null,
      id_agencia_emprego: null,
      contratado: null,
    },
    editedSituacaoValidacao: {
      id_situacao_validacao_pessoa: null,
      id_situacao_validacao: null,
      id_pessoa: null,
      nome_situacao_validacao: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      id_usuario_inclusao: null,
    },
    defaultSituacaoValidacao: {
      id_situacao_validacao_pessoa: null,
      id_situacao_validacao: null,
      id_pessoa: null,
      nome_situacao_validacao: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      id_usuario_inclusao: null,
    },
    editedSituacao: {
      id_situacao_pessoa: null,
      id_situacao: null,
      id_pessoa: null,
      nome_situacao: null,
      prioridade: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      dt_inclusao: null,
      dt_ultima_alteracao: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
    },
    defaultSituacao: {
      id_situacao_pessoa: null,
      id_situacao: null,
      id_pessoa: null,
      nome_situacao: null,
      prioridade: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      dt_inclusao: null,
      dt_ultima_alteracao: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
    },
    novaSituacao: null,
    novaSituacaoValidacao: null,
    user: null,
    token: null,
    fimProcesso: false,
    mensagemUpload: null,
    dtInicioVigenciaSituacao: null,
    dtFimVigenciaSituacao: null,
    dtInicioVigenciaSituacaoValidacao: null,
    dtFimVigenciaSituacaoValidacao: null,
    textFieldProps: {
      prependInnerIcon: "mdi-calendar",
      rules: [], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
    },
    timeProps: {
      useSeconds: true,
    },
    editingSituacao: false,
    editedSituacaoIndex: -1,
    editingSituacaoValidacao: false,
    editedSituacaoValidacaoIndex: -1,
    formPessoalValidado: false,
    formEnderecoValidado: false,
    formSituacoesValidado: false,
    formSituacoesValidacaoValidado: false,
    pcd: false,
    resultadosAxios: [],
    paises: [],
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    mapPlottedCount: 0,
    loadingMapGeocode: false,
    mapZoom: 12,
    mapCenter: [-22.9068, -43.1729],
    mapTileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    _candidatosLeafletMap: null,
    /** Menu lateral de navegação entre as seções da tela. */
    navDrawer: false,
    /** Linhas marcadas nas tabelas das abas filhas — é o que o mapa plota. */
    enderecosMapSelection: [],
    filtroPoligonoEnderecos: '',
    filtroPoligonoPreCandidatos: '',
    filtroPoligonoCandidatos: '',
    preCandidatosMapSelection: [],
  }),
  computed: {
    /** Ajuda do CSV de endereços externos: uma entrada por coluna, na ordem do modelo. */
    helpCsvEnderecosExternos() {
      return COLUNAS_CSV_ENDERECOS.map((key) => ({
        key,
        label: this.$t(`externalAddress.import.fields.${key}.label`),
        description: this.$t(`externalAddress.import.fields.${key}.description`),
        example: this.$t(`externalAddress.import.fields.${key}.example`),
      }));
    },
    importEnderecosValidas() {
      return this.importEnderecosLinhas.filter((l) => !l.temErro);
    },
    importEnderecosComErro() {
      return this.importEnderecosLinhas.filter((l) => l.temErro);
    },
    importEnderecosHeaders() {
      return [
        { text: this.$t('csv.lineNumber'), value: 'line_number' },
        { text: this.$t('externalAddress.headers.externalId'), value: 'id_endereco_externo' },
        { text: this.$t('candidate.headers.main.agency'), value: 'agencia' },
        { text: this.$t('address.postalCode'), value: 'cep' },
        { text: this.$t('address.street'), value: 'endereco' },
        { text: this.$t('address.number'), value: 'numero' },
        { text: this.$t('address.district'), value: 'bairro' },
        { text: this.$t('address.city'), value: 'cidade' },
        { text: this.$t('address.state'), value: 'estado' },
        { text: this.$t('address.country'), value: 'pais' },
        { text: this.$t('person.latitude'), value: 'lat' },
        { text: this.$t('person.longitude'), value: 'lng' },
      ];
    },
    /**
     * Override manual do tempo máximo de permanência na linha, como o backend espera:
     * inteiro positivo de minutos, ou null para herdar linha / unidade / configurações.
     */
    tempoMaximoPermanenciaPayload() {
      const v = this.validacaoTempoMaximoPermanencia;
      if (v === null || v === undefined || v === '') return null;
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
    },
    /** Override do número de linhas retornadas na validação: inteiro positivo com teto, ou null. */
    /** Padrão da tela de Configurações, usado quando o campo do menu fica vazio. */
    maxLinhasRetornoPadrao() {
      return this.$store.getters['config/maxLinhasRetornoValidacao'];
    },
    maxLinhasRetornoPayload() {
      const v = this.validacaoMaxLinhasRetorno;
      if (v === null || v === undefined || v === '') return null;
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? Math.min(Math.floor(n), this.maxLinhasRetornoLimite) : null;
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    selectedCandidatosIds() {
      return (this.candidatosSelected || [])
        .map((c) => c && c.id_pessoa)
        .filter((id) => id != null && id !== '');
    },
    csvLocalRowLimit() {
      const limite = Number(this.$store.getters['config/limiteLinhasExportacaoCsvLocal']);
      return Number.isInteger(limite) && limite > 0 ? limite : 1000;
    },
    loadingMessage() {
      return this.$t('system.messages.loading');
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('candidate.registerCandidate') : this.$t('candidate.editCandidate');
    },
    /**
     * Nome da situação que o candidato progredido vai receber. A aba de Situações
     * fica desabilitada em cadastro novo, então este é o único lugar onde o usuário
     * enxerga o que será gravado.
     */
    /**
     * Texto de origem do cadastro (endereço externo ou pré-candidato).
     *
     * Em cadastro novo é a progressão em andamento ("complete os dados"); num candidato já
     * gravado é o vínculo que veio do banco, e o texto muda para explicar por que o endereço
     * está travado — ele precisa continuar igual ao do endereço externo, que recebe a mesma
     * validação em `enderecos_validacoes`.
     */
    origemProgredida() {
      if (this.editedItem.id_endereco_externo) {
        return this.editedIndex === -1
          ? this.$t('candidate.fromExternalAddress', { id: this.editedItem.id_endereco_externo })
          : this.$t('candidate.linkedExternalAddress', { id: this.editedItem.id_endereco_externo });
      }
      if (this.editedItem.id_pre_candidato) {
        return this.$t('candidate.fromPreCandidate', { id: this.editedItem.id_pre_candidato });
      }
      return null;
    },
    /**
     * Na promoção, endereço e nome vêm do registro de origem e ficam travados: editá-los aqui
     * criaria um candidato divergente do endereço externo / pré-candidato que o originou, e a
     * validação já feita na origem deixaria de valer para o que foi gravado.
     */
    promocaoBloqueiaEndereco() {
      return !!(this.editedItem.id_endereco_externo || this.editedItem.id_pre_candidato);
    },
    /** Endereço externo não guarda nome de pessoa: só a promoção de pré-candidato trava o nome. */
    promocaoBloqueiaNome() {
      return !!this.editedItem.id_pre_candidato;
    },
    situacaoProgredidaNome() {
      // O que o candidato herda ao ser progredido e a situacao de VALIDACAO.
      const s = (this.situacoesValidacaoUsuario || [])[0];
      return s && s.nome_situacao_validacao ? s.nome_situacao_validacao : null;
    },
    formTitleSituacoes() {
      return this.editingSituacao === false ? this.$t('candidate.registerSituation') : this.$t('candidate.editSituation');
    },
    loading() {
      return this.loadingErrosEnvio ||
        this.loadingtable ||
        this.loadingtext ||
        this.loadingSave ||
        this.loadingSaveSituacoes
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isClienteSelectDisabled() {
      return this.isIdClienteDisabled || (this.editedIndex === -1 && shouldLockClienteOnCreate());
    },
    isSubgrupoDisabled() {
      return !this.grupoSelected;
    },
    agenciasAtivas() {
      return (this.agencias || []).filter((a) => a.ativo === 1 || a.ativo === true);
    },
    selectIconUnidadesFiltro() {
      if (this.unidades.length > 0 && this.filtroUnidadeSelected.length === this.unidades.length) {
        return 'mdi-close-box';
      }
      if (this.filtroUnidadeSelected.length > 0) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    turnosParaFiltroColunas() {
      const todas = this.unidades.length > 0 && this.filtroUnidadeSelected.length === this.unidades.length;
      return this.turnosByUnidades(this.filtroUnidadeSelected, todas);
    },
    allTurnoHeaderValues() {
      const values = [];
      for (const t of this.turnos || []) {
        values.push(...this.turnoFieldValuesForShift(t));
      }
      return values;
    },
    /** Chips de KPI por turno: só os turnos escolhidos no filtro, na ordem da lista de turnos. */
    kpiTurnosVisiveis() {
      const selecionados = new Set((this.filtroTurnosSelected || []).map((id) => Number(id)));
      return (this.turnos || []).filter((t) => selecionados.has(Number(t.id_turno)));
    },
    turnoColumnHeaders() {
      const selected = Array.isArray(this.filtroTurnosSelected) ? this.filtroTurnosSelected : [];
      if (!selected.length) {
        return [];
      }
      const idSet = new Set(selected.map((id) => Number(id)));
      const headers = [];
      for (const t of this.turnos || []) {
        if (!idSet.has(Number(t.id_turno))) continue;
        const cod = t.cod_turno;
        const desc = t.descricao_turno;
        headers.push({
          text: cod,
          value: `atende_${cod}`,
          sortable: false,
          filtrable: false,
          show: true,
          to_show: 1,
          to_export: 1,
        });
        if (desc) {
          headers.push({
            text: `${cod} - ${this.$t('candidate.headers.main.distance')}`,
            value: `distancia_${desc}`,
            sortable: false,
            filtrable: false,
            show: true,
            to_show: 1,
            to_export: 1,
          });
          headers.push({
            text: `${cod} - ${this.$t('candidate.rideTime.label')}`,
            value: `tempo_linha_${desc}`,
            sortable: false,
            filtrable: false,
            show: true,
            to_show: 1,
            to_export: 1,
          });
          headers.push({
            text: `${cod} - ${this.$t('candidate.headers.main.bestLine')}`,
            value: `cod_linha_${desc}`,
            sortable: false,
            filtrable: false,
            show: true,
            to_show: 1,
            to_export: 1,
          });
          headers.push({
            text: `${cod} - ${this.$t('candidate.headers.main.bestStop')}`,
            value: `cod_cerca_${desc}`,
            sortable: false,
            filtrable: false,
            show: true,
            to_show: 1,
            to_export: 1,
          });
        }
      }
      return headers;
    },
    reservaTurnosFiltrados() {
      if (!this.reservaCandidato || !this.reservaCandidato.id_unidade) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => t.id_unidade == null || String(t.id_unidade) === String(this.reservaCandidato.id_unidade)
      );
    },
    reservaCercasFiltradas() {
      if (!this.reservaLinhaSelected) {
        return [];
      }
      return (this.reservaCercas || []).filter(
        (c) => String(c.id_linha) === String(this.reservaLinhaSelected)
      );
    },
    canCreateReserva() {
      return this.reservaCandidato && this.reservaLinhaSelected && this.reservaTurnoSelected;
    },
    turnosPromoverFiltrados() {
      const ids = [...new Set(
        (this.candidatosSelected || [])
          .map((c) => Number(c.id_unidade))
          .filter((id) => !Number.isNaN(id) && id !== -1)
      )];
      if (!ids.length) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => !t.id_unidade || ids.includes(Number(t.id_unidade))
      );
    },
    usaUnidadesValidadasRestritas() {
      const validadas = Array.isArray(this.editedItemUnidadesValidadas)
        ? this.editedItemUnidadesValidadas
        : [];
      return validadas.length > 1;
    },
    unidadesParaEdicao() {
      const validadas = Array.isArray(this.editedItemUnidadesValidadas)
        ? this.editedItemUnidadesValidadas
        : [];
      if (validadas.length > 1) {
        const list = validadas.slice();
        const curId = this.editedItem && this.editedItem.id_unidade;
        if (curId != null && curId !== '') {
          const has = list.some((u) => String(u.id_unidade) === String(curId));
          if (!has) {
            const cur = (this.unidades || []).find(
              (u) => String(u.id_unidade) === String(curId)
            );
            if (cur) list.unshift(cur);
          }
        }
        return list;
      }
      return this.unidades || [];
    },
    unidadesValidadasHint() {
      if (!this.usaUnidadesValidadasRestritas) return '';
      return this.$t('candidate.validatedUnitsOnlyHint');
    },
    unidadeValidadaHeaders() {
      return [
        { text: this.$t('person.name'), value: 'nome', width: '160px' },
        { text: this.$t('candidate.headers.main.unit'), value: 'id_unidade', width: '180px', sortable: false },
        { text: this.$t('guiasMotorista.directionIda'), value: 'trajeto_ida', width: '280px', sortable: false },
        { text: this.$t('guiasMotorista.directionVolta'), value: 'trajeto_volta', width: '280px', sortable: false },
      ];
    },
    canSaveUnidadeValidada() {
      const items = this.unidadeValidadaItems || [];
      if (!items.length || this.unidadeValidadaSaving) return false;
      return items.every((i) => i && i.id_unidade != null && i.id_unidade !== '');
    },
    defaultSort() {
      return [
        { value: 'nome_completo', options: { text: this.$t('situations.increasing'), value: 1 } }];
    },
    headersCsvExport() {
      return (this.headers || [])
        .filter((h) => h && h.value && h.value !== "actions")
        .map((h) => ({
          text: h.text != null ? h.text : String(h.value),
          value: h.value,
        }));
    },
    headersSituacoesValidacao() {
      return this.headersSituacoes.map((h) => {
        if (h.value === 'id_situacao') return { ...h, value: 'id_situacao_validacao' };
        if (h.value === 'nome_situacao') {
          return { ...h, text: this.$t('validationSituation.headers.situation'), value: 'nome_situacao_validacao' };
        }
        return h;
      });
    },
    headersSituacoes() {
      return [
        { text: this.$t('candidate.headers.situations.idperson'), value: "id_pessoa", align: " d-none" },
        { text: this.$t('candidate.headers.situations.idsituation'), value: "id_situacao", align: " d-none" },
        { text: this.$t('candidate.headers.situations.situation'), value: "nome_situacao" },
        { text: this.$t('candidate.headers.situations.beginValidity'), value: "dt_inicio_vigencia_extenso" },
        { text: this.$t('candidate.headers.situations.endValidity'), value: "dt_fim_vigencia_extenso" },
        { text: this.$t('candidate.headers.situations.priority'), value: "prioridade" },
        { text: this.$t('candidate.headers.situations.actions'), value: "actions", sortable: false }]
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: "line_number" },
        { text: this.$t('company.headers.idcompany'), value: "id_empresa", align: " d-none" },
        { text: this.$tc('company.self', 1), value: "cod_empresa" },
        { text: this.$tc('client.idclient'), value: "id_cliente", align: " d-none" },
        { text: this.$tc('client.self', 1), value: "cod_cliente" },
        { text: this.$t('unit.idunit'), value: "id_unidade", align: " d-none" },
        { text: this.$tc('unit.self', 1), value: "cod_unidade" },
        { text: this.$t('person.country'), value: "pais" },
        { text: this.$t('person.CPF'), value: "cpf" },
        { text: this.$t('person.name'), value: "nome" },
        { text: this.$t('person.familyName'), value: "sobrenome" },
        { text: this.$t('address.postalCode'), value: "cep" },
        { text: this.$t('address.street'), value: "endereco" },
        { text: this.$t('address.number'), value: "numero" },
        { text: this.$t('address.complement'), value: "complemento" },
        { text: this.$t('address.district'), value: "bairro" },
        { text: this.$t('address.city'), value: "cidade" },
        { text: this.$t('address.state'), value: "estado" },
        { text: this.$t('person.telephone'), value: "telefone" },
        { text: this.$t('person.email'), value: "email" },
        { text: this.$t('person.gender'), value: "sexo" },
        { text: this.$t('person.PCD'), value: "pcd" },
        { text: this.$t('person.latitude'), value: "lat" },
        { text: this.$t('person.longitude'), value: "lng" },
        { text: this.$t('csv.fields.externalAddressId.label'), value: "id_endereco_externo" }]
    },
    headersCSVExternal() {
      return [
        { text: this.$t('csv.lineNumber'), value: 'line_number' },
        { text: this.$t('csv.fields.externalAddressId.label'), value: 'id_endereco_externo' },
        { text: this.$t('address.street'), value: 'endereco' },
        { text: this.$t('address.number'), value: 'numero' },
        { text: this.$t('address.complement'), value: 'complemento' },
        { text: this.$t('address.postalCode'), value: 'cep' },
        { text: this.$t('address.district'), value: 'bairro' },
        { text: this.$t('address.city'), value: 'cidade' },
        { text: this.$t('address.state'), value: 'estado' },
        { text: this.$t('person.country'), value: 'pais' },
        { text: this.$t('person.latitude'), value: 'lat' },
        { text: this.$t('person.longitude'), value: 'lng' }];
    },
    tabs() {
      return [
        { text: this.$t('candidate.tabs.personal'), disabled: false },
        { text: this.$t('candidate.tabs.address'), disabled: false },
        { text: this.$t('candidate.tabs.situations'), disabled: this.editedIndex === -1 },
        { text: this.$t('validationSituation.title'), disabled: this.editedIndex === -1 }];
    },
    sexo() {
      return [
        { text: this.$t('person.male'), value: 1 },
        { text: this.$t('person.female'), value: 2 },
        { text: this.$t('person.other'), value: 0 }
      ]
    },
    labelDocumentoIdentidade() {
      // Se não há país selecionado, retorna CPF por padrão
      if (!this.editedItem.id_pais) {
        return 'CPF';
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(p => p.id_pais === this.editedItem.id_pais);
      
      // Se o país for México (id_pais = 2 ou sigla = 'MX'), retorna CURP
      if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
        return 'CURP';
      }
      
      // Para Brasil ou outros países, retorna CPF
      return 'CPF';
    },
    /** Seções da tela, na ordem do menu de navegação. `value` é o índice de `mainTab`. */
    modules() {
      return [
        {
          value: 0,
          icon: 'mdi-map-marker-multiple-outline',
          text: this.$t('candidate.mainTabs.externalAddresses'),
        },
        {
          value: 1,
          icon: 'mdi-account-clock-outline',
          text: this.$t('candidate.mainTabs.preCandidates'),
        },
        {
          value: 2,
          icon: 'mdi-account-multiple-outline',
          text: this.$t('candidate.mainTabs.candidates'),
        }];
    },
    activeModuleText() {
      const found = this.modules.find((m) => m.value === this.mainTab);
      return found ? found.text : '';
    },
    mapSectionTitle() {
      if (this.mainTab === 0) return this.$t('candidate.map.titleExternalAddresses');
      if (this.mainTab === 1) return this.$t('candidate.map.titlePreCandidates');
      return this.$t('candidate.map.title');
    },
    /** Linhas marcadas na tabela da seção ativa; são elas que vão ao mapa. */
    mapRows() {
      if (this.mainTab === 0) {
        return Array.isArray(this.enderecosMapSelection) ? this.enderecosMapSelection : [];
      }
      if (this.mainTab === 1) {
        return Array.isArray(this.preCandidatosMapSelection) ? this.preCandidatosMapSelection : [];
      }
      return Array.isArray(this.candidatosSelected) ? this.candidatosSelected : [];
    },
    /** A seção ativa está filtrada pelo polígono desenhado no mapa. */
    filtroAtivoNaAba() {
      if (this.mainTab === 0) return !!this.filtroPoligonoEnderecos;
      if (this.mainTab === 1) return !!this.filtroPoligonoPreCandidatos;
      return !!this.filtroPoligonoCandidatos;
    },
    mapLegendEntries() {
      const t = (k) => this.$t("addressValidation." + k);
      return [
        { label: t("statusAttends"), color: MAP_VALIDATION_COLOR[1] },
        { label: t("statusAttendsNewStop"), color: MAP_VALIDATION_COLOR[3] },
        { label: t("statusAttendsNoSeat"), color: MAP_VALIDATION_COLOR[2] },
        { label: t("statusDoesNotAttend"), color: MAP_VALIDATION_COLOR.other },
        { label: t("statusOutsideUnit"), color: MAP_VALIDATION_COLOR[4] },
        { label: t("statusNoShiftValidation"), color: MAP_VALIDATION_COLOR.none }];
    },
    csvExportData() {
      return this.enrichCandidatosForCsvExport(this.candidatos);
    },
    helpCSV() {
      return [
        {
          label: this.$t('csv.fields.companyCode.label'),
          description: this.$t('csv.fields.companyCode.description'),
          example: this.$t('csv.fields.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('csv.fields.clientCode.label'),
          description: this.$t('csv.fields.clientCode.description'),
          example: this.$t('csv.fields.clientCode.example'),
          key: "cod_cliente"
        },
        {
          label: this.$t('csv.fields.unitCode.label'),
          description: this.$t('csv.fields.unitCode.description'),
          example: this.$t('csv.fields.unitCode.example'),
          key: "cod_unidade"
        },
        {
          label: this.$t('csv.fields.cpf.label'),
          description: this.$t('csv.fields.cpf.description'),
          example: this.$t('csv.fields.cpf.example'),
          key: "cpf"
        },
        {
          label: this.$t('csv.fields.personName.label'),
          description: this.$t('csv.fields.personName.description'),
          example: this.$t('csv.fields.personName.example'),
          key: "nome"
        },
        {
          label: this.$t('csv.fields.personFamilyName.label'),
          description: this.$t('csv.fields.personFamilyName.description'),
          example: this.$t('csv.fields.personFamilyName.example'),
          key: "sobrenome"
        },
        {
          label: this.$t('csv.fields.postalCode.label'),
          description: this.$t('csv.fields.postalCode.description'),
          example: this.$t('csv.fields.postalCode.example'),
          key: "cep"
        },
        {
          label: this.$t('csv.fields.street.label'),
          description: this.$t('csv.fields.street.description'),
          example: this.$t('csv.fields.street.example'),
          key: "endereco"
        },
        {
          label: this.$t('csv.fields.number.label'),
          description: this.$t('csv.fields.number.description'),
          example: this.$t('csv.fields.number.example'),
          key: "numero"
        },
        {
          label: this.$t('csv.fields.complement.label'),
          description: this.$t('csv.fields.complement.description'),
          example: this.$t('csv.fields.complement.example'),
          key: "complemento"
        },
        {
          label: this.$t('csv.fields.district.label'),
          description: this.$t('csv.fields.district.description'),
          example: this.$t('csv.fields.district.example'),
          key: "bairro"
        },
        {
          label: this.$t('csv.fields.city.label'),
          description: this.$t('csv.fields.city.description'),
          example: this.$t('csv.fields.city.example'),
          key: "cidade"
        },
        {
          label: this.$t('csv.fields.state.label'),
          description: this.$t('csv.fields.state.description'),
          example: this.$t('csv.fields.state.example'),
          key: "estado"
        },
        {
          label: this.$t('csv.fields.country.label'),
          description: this.$t('csv.fields.country.description'),
          example: this.$t('csv.fields.country.example'),
          key: "pais"
        },
        {
          label: this.$t('csv.fields.phone.label'),
          description: this.$t('csv.fields.phone.description'),
          example: this.$t('csv.fields.phone.example'),
          key: "telefone"
        },
        {
          label: this.$t('csv.fields.email.label'),
          description: this.$t('csv.fields.email.description'),
          example: this.$t('csv.fields.email.example'),
          key: "email"
        },
        {
          label: this.$t('csv.fields.gender.label'),
          description: this.$t('csv.fields.gender.description'),
          example: this.$t('csv.fields.gender.example'),
          key: "sexo"
        },
        {
          label: this.$t('csv.fields.pcd.label'),
          description: this.$t('csv.fields.pcd.description'),
          example: this.$t('csv.fields.pcd.example'),
          key: "pcd"
        },
        {
          label: this.$t('csv.fields.latitude.label'),
          description: this.$t('csv.fields.latitude.description'),
          example: this.$t('csv.fields.latitude.example'),
          key: "lat"
        },
        {
          label: this.$t('csv.fields.longitude.label'),
          description: this.$t('csv.fields.longitude.description'),
          example: this.$t('csv.fields.longitude.example'),
          key: "lng"
        },
        {
          label: this.$t('csv.fields.externalAddressId.label'),
          description: this.$t('csv.fields.externalAddressId.description'),
          example: this.$t('csv.fields.externalAddressId.example'),
          key: "id_endereco_externo"
        }]
    }
  },
  watch: {
    dialog(val) {
      if (val && this.editedIndex === -1) {
        const scopedId = getScopedClienteIdForCreate();
        if (scopedId != null) {
          this.editedItem.id_cliente = scopedId;
        }
        this.$nextTick(() => this.syncUnidadeSelect());
      }
      val || this.close();
    },
    'editedItem.id_pais'() {
      // Revalida o campo CPF/CURP quando o país mudar
      if (this.$refs.formPessoal && this.editedItem.cpf) {
        this.$nextTick(() => {
          this.$refs.formPessoal.validate();
        });
      }
      // Revalida o campo CEP/Código Postal quando o país mudar
      if (this.$refs.formEndereco && this.editedItem.cep) {
        this.$nextTick(() => {
          this.$refs.formEndereco.validate();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.formPessoal) {
        this.$refs.formPessoal.resetValidation();
      }
      if (this.$refs.formEndereco) {
        this.$refs.formEndereco.resetValidation();
      }
    },
    candidatosSelected: {
      handler() {
        this.onMapSelectionChanged();
      },
    },
    enderecosMapSelection: {
      handler() {
        this.onMapSelectionChanged();
      },
    },
    preCandidatosMapSelection: {
      handler() {
        this.onMapSelectionChanged();
      },
    },
    // Recarregar a tabela (ex.: depois de revalidar) troca os objetos das linhas: a seleção
    // continua nas mesmas linhas, agora com os dados novos. Quem saiu da página fica como está.
    candidatos(linhas) {
      if (!this.candidatosSelected.length) return;
      const porChave = new Map((linhas || []).map((l) => [l.id_pessoa, l]));
      this.candidatosSelected = this.candidatosSelected.map((s) => porChave.get(s.id_pessoa) || s);
    },
    // Trocar de seção troca o conjunto de marcadores: reenquadra e revalida o tamanho
    // do mapa, que fica escondido enquanto a coluna está fora de tela.
    mainTab(value) {
      if (value === 2) {
        this.ensureCandidatosCarregados();
      }
      this.onMapSelectionChanged();
    },
    filtroUnidadeSelected: {
      handler(next, prev) {
        const previous = Array.isArray(prev) ? [...prev] : [...this.previousFiltroUnidadeSelected];
        const current = Array.isArray(next) ? next : [];
        this.syncTurnosFromUnidadeSelection(previous, current);
        this.previousFiltroUnidadeSelected = [...current];
      },
      deep: true,
    },
    filtroTurnosSelected: {
      handler(val) {
        const allowed = new Set(
          (this.turnosParaFiltroColunas || []).map((t) => Number(t.id_turno))
        );
        const next = (val || []).filter((id) => allowed.has(Number(id)));
        if (next.length !== (val || []).length) {
          this.filtroTurnosSelected = next;
        }
      },
      deep: true,
    },
  },
  created() {
    // Marcadores e cache de coordenadas fora do data: milhares de linhas não devem ser reativas.
    this.geocodeCache = {};
    this._mapMarcadores = [];
    this._mapGrupoMarcadores = null;
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.aplicarSelecaoRevalidacao();
    this.populaRecursos();
  },
  mounted() {
    this.$root.$emit('eventshowback', true);
  },
  methods: {
    /** Endereços externos da tabela no formato do CSV (agência pelo código), para reimportar depois. */
    async carregaEnderecosParaCsv(onProgress) {
      const rows = await this.$refs.enderecosExternosTab.loadItemsForExport(onProgress);
      return (rows || []).map((r) => ({ ...r, agencia: r.cod_agencia_emprego || r.nome_agencia_emprego || '' }));
    },
    importEnderecosFechar() {
      this.importEnderecosDialog = false;
      this.importEnderecosArquivo = null;
      this.importEnderecosErro = null;
      this.importEnderecosLinhas = [];
    },
    async importEnderecosLerArquivo(arquivo) {
      this.importEnderecosErro = null;
      this.importEnderecosLinhas = [];
      if (!arquivo) return;
      this.importEnderecosLendo = true;
      try {
        let texto = await lerComoTexto(arquivo, 'UTF-8');
        // Planilha salva pelo Excel em ANSI: caractere inválido em UTF-8 vira U+FFFD.
        if (texto.includes('\uFFFD')) {
          texto = await lerComoTexto(arquivo, 'windows-1252');
        }
        texto = texto.replace(/^\uFEFF/, '');
        const primeiraLinha = texto.split('\n')[0] || '';
        const sep = (primeiraLinha.match(/;/g) || []).length >= (primeiraLinha.match(/,/g) || []).length ? ';' : ',';
        const [cabecalho, ...dados] = quebrarCsv(texto, sep);
        const colunas = (cabecalho || []).map(normalizarCabecalhoCsv);
        if (!colunas.some((c) => COLUNAS_CSV_ENDERECOS.includes(c))) {
          this.importEnderecosErro = this.$t('externalAddress.import.noKnownColumns');
          return;
        }
        if (dados.length === 0) {
          this.importEnderecosErro = this.$t('externalAddress.import.emptyFile');
          return;
        }
        const registros = dados.map((celulas) => {
          const reg = {};
          colunas.forEach((col, i) => {
            if (COLUNAS_CSV_ENDERECOS.includes(col)) reg[col] = celulas[i] != null ? String(celulas[i]).trim() : '';
          });
          return reg;
        });
        this.importEnderecosLinhas = this.importEnderecosValidarRegistros(registros);
      } catch (e) {
        this.importEnderecosErro = (e && e.message) || String(e);
      } finally {
        this.importEnderecosLendo = false;
      }
    },
    /** Resolve o texto da agência (código, nome ou "código - nome"), como o backend faz. */
    importEnderecosResolverAgencia(escrita) {
      const t = String(escrita || '').trim();
      if (!t) return { id: null };
      const encontradas = (this.agencias || []).filter((a) => {
        const cod = a.cod_agencia != null ? String(a.cod_agencia).trim() : '';
        const nome = a.nome != null ? String(a.nome).trim() : '';
        return t === cod || t === nome || t === `${cod} - ${nome}`;
      });
      if (encontradas.length === 0) return { erro: this.$t('externalAddress.import.agencyNotFound') };
      if (encontradas.length > 1) return { erro: this.$t('externalAddress.import.agencyAmbiguous') };
      return { id: encontradas[0].id_agencia_emprego };
    },
    /**
     * Confere cada linha antes de enviar: o endpoint rejeita o lote inteiro (400) por um item
     * com código repetido, sem endereço/coordenada ou com agência desconhecida.
     */
    importEnderecosValidarRegistros(registros) {
      const contagem = new Map();
      registros.forEach((r) => {
        const id = r.id_endereco_externo || '';
        if (id) contagem.set(id, (contagem.get(id) || 0) + 1);
      });
      return registros.map((r, i) => {
        // +2: a linha 1 do arquivo é o cabeçalho.
        const linha = { ...r, line_number: i + 2 };
        const erros = {};
        // Código externo é opcional (como no cadastro unitário); só não pode repetir no arquivo.
        if (r.id_endereco_externo && contagem.get(r.id_endereco_externo) > 1) {
          erros.error_id_endereco_externo = this.$t('externalAddress.import.duplicateId');
        }
        const agencia = this.importEnderecosResolverAgencia(r.agencia);
        if (agencia.erro) erros.error_agencia = agencia.erro;
        linha.id_agencia_emprego = agencia.id != null ? agencia.id : null;

        const lat = numeroOuNull(r.lat);
        const lng = numeroOuNull(r.lng);
        if (Number.isNaN(lat) || (lat != null && Math.abs(lat) > 90)) {
          erros.error_lat = this.$t('externalAddress.import.invalidCoordinate');
        }
        if (Number.isNaN(lng) || (lng != null && Math.abs(lng) > 180)) {
          erros.error_lng = this.$t('externalAddress.import.invalidCoordinate');
        }
        if ((lat == null) !== (lng == null) && !erros.error_lat && !erros.error_lng) {
          erros[lat == null ? 'error_lat' : 'error_lng'] = this.$t('externalAddress.import.incompleteCoordinate');
        }
        const temCoordenada = lat != null && lng != null;
        // Sem coordenada o backend geocodifica: precisa ao menos de rua ou CEP.
        if (!temCoordenada && !r.endereco && !r.cep) {
          erros.error_endereco = this.$t('externalAddress.import.missingAddress');
        }
        linha.lat = Number.isNaN(lat) ? r.lat : lat;
        linha.lng = Number.isNaN(lng) ? r.lng : lng;
        linha.temErro = Object.keys(erros).length > 0;
        if (linha.temErro) linha.error_line = Object.values(erros).join('\n');
        return Object.assign(linha, erros);
      });
    },
    importEnderecosConfirmar() {
      const itens = this.importEnderecosValidas.map((l) => ({
        id_unico_endereco_externo: null,
        id_endereco_externo: l.id_endereco_externo || null,
        id_agencia_emprego: l.id_agencia_emprego,
        cep: l.cep || null,
        endereco: l.endereco || null,
        numero: l.numero || null,
        bairro: l.bairro || null,
        cidade: l.cidade || null,
        estado: l.estado || null,
        pais: l.pais || null,
        lat: l.lat,
        lng: l.lng,
      }));
      this.importEnderecosFechar();
      // O envio fica na aba: usa as opções de validação e o diálogo de resultado dela.
      this.$refs.enderecosExternosTab.cadastraEnderecosEmMassa(itens);
    },

    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatepessoa");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/createpessoa");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletepessoa");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.resultadosAxios = [];
      if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      Promise.all([
        this.populaTurnos(),
        this.populaUnidades(),
        this.populaAgencias(),
        this.populaClientes(),
        this.populaEmpresas(),
        this.populaSituacoes(),
        this.populaSituacoesValidacao(),
        this.populaGrupos()
      ]).then(() => {
        this.$refs.alertasAxios.showAlerts(this.resultadosAxios);
      })
      this.populaPaises();
      // Só quando a tela já abre na seção de candidatos; nas outras, quem dispara é o
      // watch de `mainTab`, na primeira vez que o usuário entra nela.
      if (this.mainTab === 2) {
        this.ensureCandidatosCarregados();
      }
    },
    checkCountry() {
      this.editedItem.id_pais = this.paises.find(p => p.sigla === defaultCountry)?.id_pais;
    },
    populaPaises() {
      apiController.request(apiController.endpoints.getallPaises, {
        onSuccess: (response) => {
          this.paises = response.data;
          this.paises.forEach(pais => {
            pais.nome = translateDbField(
              pais.translation_key,
              pais.nome
            );
            return pais;
          });
          this.checkCountry();
        },
      });
    },
    /**
     * Recarrega a lista já carregada (depois de salvar, excluir ou promover alguém).
     * Enquanto a seção de candidatos não foi aberta não há o que atualizar: a guarda de
     * `serverTableLoad` segura a requisição e a lista vem completa quando ela abrir.
     */
    populaCandidatos() {
      return this.serverTableLoad();
    },
    /**
     * Carrega a página atual da lista de candidatos. `candidatosCarregados` destrava os
     * eventos que a tabela emite ao montar (update:options), que até a seção ser aberta
     * não devem virar requisição.
     */
    ensureCandidatosCarregados() {
      this.candidatosCarregados = true;
      const sel = this.selecaoCandidatos;
      if (sel) {
        // Lista só os candidatos do relatório, numa página, e os marca para revalidar.
        this.selecaoCandidatos = null;
        this.filtroIdsCandidatos = sel.ids.join(',');
        this.searchFilters = { ...this.searchFilters, ids: this.filtroIdsCandidatos };
        this.pageNumber = 1;
        this.numberOfRows = this.itemsPerPageLastOption;
        return Promise.resolve(this.serverTableLoad()).then(() => {
          this.candidatosSelected = this.candidatos.slice();
        });
      }
      return this.serverTableLoad();
    },
    /** Abre na aba da origem da seleção trazida do relatório de KPIs de endereços externos. */
    aplicarSelecaoRevalidacao() {
      const sel = consumirSelecaoRevalidacao();
      if (!sel) return;
      this.mainTab = ABA_POR_ORIGEM[sel.origem];
      if (sel.origem === 'E') this.selecaoEnderecos = { ids: sel.ids };
      else if (sel.origem === 'P') this.selecaoPreCandidatos = { ids: sel.ids };
      else this.selecaoCandidatos = { ids: sel.ids };
    },
    serverTableBaseFilters() {
      const base = this.filtroIdsCandidatos ? { ids: this.filtroIdsCandidatos } : {};
      if (this.filtroPoligonoCandidatos) base.poligono = this.filtroPoligonoCandidatos;
      return base;
    },
    limparFiltroIdsCandidatos() {
      this.filtroIdsCandidatos = '';
      const resto = { ...this.searchFilters };
      delete resto.ids;
      this.searchFilters = resto;
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    turnoFieldValuesForShift(t) {
      if (!t) return [];
      const values = [`atende_${t.cod_turno}`, `valido_${t.cod_turno}`];
      if (t.descricao_turno) {
        values.push(
          `distancia_${t.descricao_turno}`,
          `tempo_linha_${t.descricao_turno}`,
          `cod_linha_${t.descricao_turno}`,
          `cod_cerca_${t.descricao_turno}`,
          `cod_validacao_${t.descricao_turno}`
        );
      }
      return values;
    },
    turnosByUnidades(idsUnidade, mostrarTodas) {
      const list = this.turnos || [];
      if (mostrarTodas) {
        return list;
      }
      const ids = Array.isArray(idsUnidade)
        ? idsUnidade
        : (idsUnidade != null && idsUnidade !== '' ? [idsUnidade] : []);
      if (!ids.length) {
        return list.filter((t) => t.id_unidade == null || t.id_unidade === '');
      }
      const idSet = new Set(ids.map((id) => Number(id)));
      return list.filter((t) => {
        if (t.id_unidade == null || t.id_unidade === '') {
          return true;
        }
        return idSet.has(Number(t.id_unidade));
      });
    },
    turnoPertenceAUnidade(turno, idUnidade) {
      const uid = Number(idUnidade);
      const turnoUid = turno.id_unidade == null || turno.id_unidade === ''
        ? null
        : Number(turno.id_unidade);
      if (turnoUid === null) {
        return uid === -1;
      }
      return turnoUid === uid;
    },
    turnoIdsAssociadosAUnidade(idUnidade) {
      return (this.turnos || [])
        .filter((t) => this.turnoPertenceAUnidade(t, idUnidade))
        .map((t) => t.id_turno);
    },
    syncTurnosFromUnidadeSelection(previousUnits, nextUnits) {
      const prev = new Set((previousUnits || []).map((id) => Number(id)));
      const next = Array.isArray(nextUnits) ? nextUnits : [];
      const nextSet = new Set(next.map((id) => Number(id)));

      if (!next.length) {
        this.filtroTurnosSelected = [];
        return;
      }

      if (this.unidades.length > 0 && next.length === this.unidades.length) {
        const turnos = new Set();
        for (const idUnidade of next) {
          for (const idTurno of this.turnoIdsAssociadosAUnidade(idUnidade)) {
            turnos.add(Number(idTurno));
          }
        }
        this.filtroTurnosSelected = [...turnos];
        return;
      }

      const added = next.filter((id) => !prev.has(Number(id)));
      const removed = [...prev].filter((id) => !nextSet.has(id));
      const turnos = new Set((this.filtroTurnosSelected || []).map((id) => Number(id)));

      for (const idUnidade of added) {
        for (const idTurno of this.turnoIdsAssociadosAUnidade(idUnidade)) {
          turnos.add(Number(idTurno));
        }
      }

      for (const idUnidade of removed) {
        for (const idTurno of this.turnoIdsAssociadosAUnidade(idUnidade)) {
          const turno = (this.turnos || []).find((t) => Number(t.id_turno) === Number(idTurno));
          if (!turno) continue;
          const stillRelevant = next.some((uid) => this.turnoPertenceAUnidade(turno, uid));
          if (!stillRelevant) {
            turnos.delete(Number(idTurno));
          }
        }
      }

      this.filtroTurnosSelected = [...turnos];
    },
    toggleAllUnidadesFiltro() {
      this.$nextTick(() => {
        if (this.filtroUnidadeSelected.length === this.unidades.length) {
          this.filtroUnidadeSelected = [];
        } else {
          this.filtroUnidadeSelected = this.unidades.map((u) => u.id_unidade);
        }
      });
    },
    serverTableLoad(options) {
      // Ignora os eventos que a tabela emite ao montar, enquanto a seção não foi aberta.
      if (!this.candidatosCarregados) return Promise.resolve();
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalCandidatos,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      return (async () => {
        try {
          const response = await apiController.request(apiController.endpoints.getallCandidatos, {
            data: params,
            config: { timeout: 120000 },
            silent: true,
          });
          const data = response.data;
          if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
            this.candidatos = data.items;
            const updates = computePageState(data, { page, rowsPerPage, sortByArr, sortDescArr }, state, this.itemsPerPageLastOption);
            this.totalCandidatos = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.candidatos = Array.isArray(data) ? data : [];
            this.totalCandidatos = this.candidatos.length;
          }
          if (data && data.erro) this.resultadosAxios.push(data);
          this.loadingtable = false;
        } catch (e) {
          this.loadingtable = false;
          EventBus.$emit('show-error', { error: e });
          throw e;
        }
      })();
    },
    async loadItemsForExport(onProgress) {
      const selected = this.candidatosSelected;
      if (selected && selected.length > 0) {
        if (typeof onProgress === 'function') onProgress(100);
        return this.enrichCandidatosForCsvExport(selected.slice());
      }
      const items = await fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallCandidatos,
            { data: params, config: { timeout: 120000 }, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalCandidatos,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        onProgress,
      });
      return this.enrichCandidatosForCsvExport(items);
    },
    enrichCandidatosForCsvExport(items) {
      const clientes = Array.isArray(this.clientes) ? this.clientes : [];
      const empresas = Array.isArray(this.empresas) ? this.empresas : [];
      return (items || []).map((c) => {
        const cliente = clientes.find(
          (cl) => Number(cl.id_cliente) === Number(c.id_cliente)
        );
        const empresa = cliente
          ? empresas.find((e) => Number(e.id_empresa) === Number(cliente.id_empresa))
          : null;
        return {
          ...c,
          cod_empresa: empresa
            ? empresa.cod_integracao
            : (c.cod_empresa || ''),
          cod_cliente: cliente
            ? cliente.codigo_cliente
            : (c.cod_cliente || ''),
          pais: c.pais || c.sigla_pais || '',
        };
      });
    },
    turnosForUnidade(idUnidade) {
      if (idUnidade == null || idUnidade === '') {
        return (this.turnos || []).filter((t) => t.id_unidade == null || t.id_unidade === '');
      }
      return this.turnosByUnidades([idUnidade], false);
    },
    bestValidoAmongTurnos(candidato) {
      let bestVal = null;
      let bestRank = -1;
      for (const t of this.turnosForUnidade(candidato.id_unidade)) {
        const key = `valido_${t.cod_turno}`;
        if (!Object.prototype.hasOwnProperty.call(candidato, key)) continue;
        const raw = candidato[key];
        if (raw === null || raw === undefined || raw === "") continue;
        const v = Number(raw);
        const rank = mapMarkerPriorityRank(v);
        if (rank < 0) continue;
        if (rank > bestRank) {
          bestRank = rank;
          bestVal = v;
        }
      }
      return bestVal;
    },
    mapMarkerColorForBestValido(bestVal) {
      if (bestVal === null) return MAP_VALIDATION_COLOR.none;
      return mapColorForValidoCode(bestVal);
    },
    labelForValidoCode(v) {
      if (v === null || v === undefined || v === "") {
        return this.$t("addressValidation.statusNoShiftValidation");
      }
      const n = Number(v);
      if (!Number.isFinite(n)) {
        return this.$t("addressValidation.statusNoShiftValidation");
      }
      switch (n) {
        case 1:
          return this.$t("addressValidation.statusAttends");
        case 2:
          return this.$t("addressValidation.statusAttendsNoSeat");
        case 3:
          return this.$t("addressValidation.statusAttendsNewStop");
        case 4:
          return this.$t("addressValidation.statusOutsideUnit");
        default:
          return this.$t("addressValidation.statusDoesNotAttend");
      }
    },
    /**
     * Endereço em texto para geocodificar/exibir. Serve às três seções: candidatos e
     * endereços externos usam `endereco`, pré-candidatos usam `rua`; só endereços externos
     * trazem `estado`/`pais`.
     */
    buildGeocodeAddressString(c) {
      const num =
        c.numero != null && String(c.numero).trim() !== ""
          ? String(c.numero).trim()
          : null;
      const logradouro =
        c.endereco != null && String(c.endereco).trim() !== "" ? c.endereco : c.rua;
      const parts = [
        logradouro,
        num,
        c.bairro,
        c.cidade,
        c.estado,
        c.cep,
        c.sigla_pais || c.pais || defaultCountry].filter((x) => x != null && String(x).trim() !== "");
      return parts.join(", ");
    },
    /**
     * Chave da linha no `geocodeCache`. Cada seção tem seu próprio identificador, então o
     * prefixo evita que um id de endereço externo colida com um id de endereço de pessoa.
     */
    mapRowKey(row) {
      if (!row) return null;
      if (this.mainTab === 0) {
        // Id próprio da linha: o código externo é opcional no cadastro de endereços.
        return row.id_unico_endereco_externo != null ? "ee-" + row.id_unico_endereco_externo : null;
      }
      if (this.mainTab === 1) {
        return row.id_pre_candidato != null ? "pc-" + row.id_pre_candidato : null;
      }
      return row.id_endereco != null ? "ce-" + row.id_endereco : null;
    },
    /**
     * `validacao_por_turno` do pré-candidato: o backend grava um JSON id_turno -> código
     * 0..4, mas o driver pode devolvê-lo já como objeto ou ainda como string.
     */
    parseValidacaoPorTurno(raw) {
      if (raw == null) return null;
      if (typeof raw === "object") return raw;
      try {
        const parsed = JSON.parse(String(raw));
        return parsed && typeof parsed === "object" ? parsed : null;
      } catch (e) {
        return null;
      }
    },
    /** Melhor código de validação da linha, na convenção de cores do mapa. */
    mapRowBestValido(row) {
      if (this.mainTab === 0) {
        const v = row.melhor_valido;
        return v == null || v === "" ? null : Number(v);
      }
      if (this.mainTab === 1) {
        const mapa = this.parseValidacaoPorTurno(row.validacao_por_turno);
        if (!mapa) return null;
        let bestVal = null;
        let bestRank = -1;
        for (const k of Object.keys(mapa)) {
          const v = Number(mapa[k]);
          const rank = mapMarkerPriorityRank(v);
          if (rank < 0) continue;
          if (rank > bestRank) {
            bestRank = rank;
            bestVal = v;
          }
        }
        return bestVal;
      }
      return this.bestValidoAmongTurnos(row);
    },
    /** Campos do balão do marcador que variam por seção. */
    mapRowPopupFields(row) {
      if (this.mainTab === 0) {
        // Endereço sem código externo aparece pelo id próprio, como na tabela da aba.
        const idEndereco = row.id_endereco_externo != null && String(row.id_endereco_externo).trim() !== ""
          ? row.id_endereco_externo
          : `#${row.id_unico_endereco_externo}`;
        return {
          nome: row.agencia_emprego
            ? `${idEndereco} — ${row.agencia_emprego}`
            : `${idEndereco}`,
          ultimaValidacao: row.dt_validacao_extenso,
          situacao: null,
          turnoLinhas: (this.turnos || [])
            .map((t) => {
              const label = row[`atende_${t.cod_turno}`];
              if (label == null || label === "" || label === "-") return null;
              return `${t.cod_turno}: ${label}`;
            })
            .filter(Boolean),
        };
      }
      if (this.mainTab === 1) {
        return {
          nome: row.nome_completo || `#${row.id_pre_candidato}`,
          ultimaValidacao: null,
          situacao: row.nome_situacao
            ? `${this.$tc("situation.self", 1)}: ${row.nome_situacao}`
            : null,
          turnoLinhas: row.turno_desejado
            ? [`${this.$t("preCandidate.headers.desiredShift")}: ${row.turno_desejado}`]
            : [],
        };
      }
      return {
        nome: row.nome_completo || "",
        ultimaValidacao: row.dt_validacao_extenso,
        situacao: (this.$t("validationSituation.headers.situation") + ": ") +
          (row.nome_situacao_validacao || this.$t("validationSituation.notValidated")),
        turnoLinhas: this.turnosForUnidade(row.id_unidade)
          .map((t) => {
            const label = row[`atende_${t.cod_turno}`];
            if (label == null || label === "" || label === "-") return null;
            return `${t.cod_turno}: ${label}`;
          })
          .filter(Boolean),
      };
    },
    /** Troca a seção ativa e fecha o menu de navegação. */
    changeModule(module) {
      this.mainTab = module.value;
      this.navDrawer = false;
    },
    /** Coordenadas já persistidas na linha (evita geocode na API). */
    parseLatLngFromCandidatoRow(c) {
      if (!c || c.lat == null || c.lng == null) return null;
      const lat = Number(c.lat);
      const lng = Number(c.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    },
    seedGeocodeCacheFromStoredCoords(candidates) {
      const list = Array.isArray(candidates) ? candidates : [];
      // Só candidatos: a linha marcada pode vir sem lat/lng e a da tabela tê-los.
      const table = this.mainTab === 2 && Array.isArray(this.candidatos) ? this.candidatos : [];
      for (const c of list) {
        const key = this.mapRowKey(c);
        if (key == null) continue;
        if (this.geocodeCache[key]) continue;
        const fromTable = table.find((r) => r.id_pessoa === c.id_pessoa);
        const merged = fromTable ? Object.assign({}, fromTable, c) : c;
        const ll = this.parseLatLngFromCandidatoRow(merged);
        if (!ll) continue;
        this.geocodeCache[key] = { lat: ll.lat, lng: ll.lng };
      }
    },
    /**
     * O servidor filtra todos os cadastros da seção ativa pelo polígono ("lat,lng;lat,lng;...")
     * e a aba lista e marca os que estão dentro, somando ao que já estava selecionado.
     */
    aplicarFiltroPoligono(poligono) {
      if (this.mainTab === 0) this.filtroPoligonoEnderecos = poligono;
      else if (this.mainTab === 1) this.filtroPoligonoPreCandidatos = poligono;
      else this.aplicarPoligonoCandidatos(poligono);
    },
    /** Tira o filtro de área da seção ativa (a seleção feita é mantida). */
    removerFiltroPoligono() {
      if (this.mainTab === 0) this.filtroPoligonoEnderecos = '';
      else if (this.mainTab === 1) this.filtroPoligonoPreCandidatos = '';
      else this.limparPoligonoCandidatos();
    },
    aplicarPoligonoCandidatos(poligono) {
      this.filtroPoligonoCandidatos = poligono;
      this.searchFilters = { ...this.searchFilters, poligono };
      this.pageNumber = 1;
      this.numberOfRows = this.itemsPerPageLastOption;
      Promise.resolve(this.serverTableLoad()).then(() => {
        const marcados = new Set(this.candidatosSelected.map((l) => l.id_pessoa));
        this.candidatosSelected = this.candidatosSelected.concat(this.candidatos.filter((l) => !marcados.has(l.id_pessoa)));
        this.avisarAreaAplicada({ selecionados: this.candidatos.length, total: this.totalCandidatos });
      });
    },
    limparPoligonoCandidatos() {
      this.filtroPoligonoCandidatos = '';
      const resto = { ...this.searchFilters };
      delete resto.poligono;
      this.searchFilters = resto;
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    avisarAreaAplicada({ selecionados, total }) {
      const truncado = total > selecionados;
      EventBus.$emit("show-alert", {
        tipo: !selecionados ? "warning" : (truncado ? "warning" : "success"),
        mensagem: truncado
          ? this.$t("candidate.map.areaResultTruncated", { selecionados, total })
          : this.$t("candidate.map.areaResult", { selecionados }),
        duracao: 6000,
      });
    },
    onCandidatosMapReady() {
      this.$nextTick(() => {
        const ref = this.$refs.candidatosMap;
        this._candidatosLeafletMap = ref && ref.mapObject ? ref.mapObject : null;
        if (this._candidatosLeafletMap) {
          this._candidatosLeafletMap.invalidateSize();
          this.renderMarcadores();
        }
      });
    },
    onMapSelectionChanged() {
      clearTimeout(this._mapSelTimer);
      this._mapSelTimer = setTimeout(() => {
        this.seedGeocodeCacheFromStoredCoords(this.mapRows);
        this.renderMarcadores();
        this.fitMapToMarkers();
      }, 60);
    },
    /** Dados de cada marcador: calculados uma vez por renderização, sem passar pelo Vue. */
    buildMapMarkers() {
      const markers = [];
      for (const c of this.mapRows) {
        const key = this.mapRowKey(c);
        if (key == null) continue;
        const g = this.geocodeCache[key];
        if (!g || g.lat == null || g.lng == null) continue;
        markers.push({ key, row: c, latLng: [g.lat, g.lng], color: this.mapMarkerColorForBestValido(this.mapRowBestValido(c)) });
      }
      return markers;
    },
    /** Marcadores em canvas (circleMarker); o popup só é montado no clique. */
    renderMarcadores() {
      const map = this.areaMapa();
      if (!map) return;
      if (this._mapGrupoMarcadores) map.removeLayer(this._mapGrupoMarcadores);
      this._mapMarcadores = this.buildMapMarkers();
      this.mapPlottedCount = this._mapMarcadores.length;
      const camadas = this._mapMarcadores.map((m) => {
        const marcador = L.circleMarker(m.latLng, {
          radius: 7, color: "#fff", weight: 2, fillColor: m.color, fillOpacity: 1,
        });
        marcador.bindPopup(() => this.buildPopupElement(m.row));
        return marcador;
      });
      this._mapGrupoMarcadores = L.layerGroup(camadas).addTo(map);
      camadas.forEach((l) => l.bringToFront());
    },
    buildPopupElement(row) {
      const best = this.mapRowBestValido(row);
      const f = this.mapRowPopupFields(row);
      const el = document.createElement("div");
      el.className = "candidatos-map-popup";
      const add = (text, cls) => {
        if (!text) return;
        const d = document.createElement("div");
        if (cls) d.className = cls;
        d.textContent = text;
        el.appendChild(d);
      };
      const nome = document.createElement("strong");
      nome.textContent = f.nome || "";
      el.appendChild(nome);
      add(this.labelForValidoCode(best), "text-caption font-weight-medium");
      if (f.ultimaValidacao) add(`${this.$t("candidate.headers.main.lastValidation")}: ${f.ultimaValidacao}`, "text-caption grey--text text--darken-1");
      add(f.situacao, "text-caption");
      if (row.zonas_risco_label) {
        add(`${this.$t("area.riskZone")}: ${row.zonas_risco_label}`, "text-caption red--text text--darken-2 font-weight-medium");
      }
      (f.turnoLinhas || []).forEach((line) => add(line, "text-caption grey--text text--darken-1"));
      add(this.buildGeocodeAddressString(row), "text-caption grey--text text--darken-1 mt-1");
      return el;
    },
    fitMapToMarkers() {
      this.$nextTick(() => {
        const map = this._candidatosLeafletMap || (this.$refs.candidatosMap && this.$refs.candidatosMap.mapObject);
        if (!map) return;
        map.invalidateSize();
        const pts = (this._mapMarcadores || []).map((m) => m.latLng).filter((ll) => ll && ll.length === 2);
        if (!pts.length) return;
        if (pts.length === 1) {
          map.setView(pts[0], 14);
          return;
        }
        map.fitBounds(L.latLngBounds(pts), { padding: [28, 28], maxZoom: 15 });
      });
    },
    async refreshCandidateMapPositions() {
      this.loadingMapGeocode = true;
      try {
        this.seedGeocodeCacheFromStoredCoords(this.mapRows);
        const addressToEnderecoIds = new Map();
        for (const c of this.mapRows) {
          const key = this.mapRowKey(c);
          if (key == null) continue;
          if (this.geocodeCache[key]) continue;
          const addr = this.buildGeocodeAddressString(c);
          if (!addr || addr.trim().length < 8) continue;
          if (!addressToEnderecoIds.has(addr)) addressToEnderecoIds.set(addr, []);
          const ids = addressToEnderecoIds.get(addr);
          if (ids.indexOf(key) === -1) ids.push(key);
        }
        const uniqueAddrs = [...addressToEnderecoIds.keys()];
        const BATCH = 8;
        for (let i = 0; i < uniqueAddrs.length; i += BATCH) {
          const batch = uniqueAddrs.slice(i, i + BATCH);
          const res = await apiController.request(apiController.endpoints.googleMapsGetGeocodebulk, {
            data: { addresses: batch },
            silent: true,
          });
          if (res.data && res.data.results && res.data.results.length) {
            const byAddr = {};
            res.data.results.forEach((r) => {
              if (r.originalAddress) byAddr[String(r.originalAddress).trim()] = r;
            });
            batch.forEach((addr) => {
              const r = byAddr[String(addr).trim()];
              if (r && r.latitude != null && r.longitude != null) {
                const lat = Number(r.latitude);
                const lng = Number(r.longitude);
                const ids = addressToEnderecoIds.get(addr) || [];
                ids.forEach((id) => {
                  this.geocodeCache[id] = { lat, lng };
                });
              }
            });
          }
          if (i + BATCH < uniqueAddrs.length) {
            await new Promise((r) => setTimeout(r, 250));
          }
        }
        this.renderMarcadores();
        this.fitMapToMarkers();
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingMapGeocode = false;
      }
    },
    agenciaItemText(item) {
      if (!item) {
        return '';
      }
      const cod = item.cod_agencia != null ? String(item.cod_agencia).trim() : '';
      const nome = item.nome != null ? String(item.nome).trim() : '';
      if (cod && nome) {
        return cod + ' - ' + nome;
      }
      return nome || cod;
    },
    populaAgencias() {
      apiController.request(apiController.endpoints.getallAgenciasemprego, {
        onSuccess: (response) => {
          this.agencias = response.data || [];
        },
      });
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        onSuccess: (response) => {
          this.turnos = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
      });
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = response.data || [];
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
      });
    },
    populaSituacoes() {
      apiController.request(apiController.endpoints.getallSituacoes, {
        silent: true,
        onSuccess: (response) => {
          this.situacoes = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
        onError: (e) => {
          console.log(e);
          this.erro = {
            type: "Axios",
            message: e.message,
            status: e.response.status
          };
          this.$refs.erroDialog.showError();
        },
      });
    },
    populaSituacoesValidacao() {
      return apiController.request(apiController.endpoints.getallSituacoesvalidacao, {
        onSuccess: (response) => {
          this.situacoesValidacao = response.data;
        },
      });
    },
    populaSituacoesValidacaoUsuarios() {
      // Sem id nao ha o que carregar (cadastro novo). O buildUrl do apiController
      // omite silenciosamente segmentos nulos, o que viraria um 404 sem explicacao
      // na rota /:id em vez de simplesmente nao chamar.
      const idPessoa = this.editedItem && this.editedItem.id_pessoa;
      if (idPessoa == null || idPessoa === "") {
        this.situacoesValidacaoUsuario = [];
        return Promise.resolve();
      }
      return apiController.request(apiController.endpoints.getallSituacoesvalidacaopessoaporid, {
        params: { id: idPessoa },
        onSuccess: (response) => {
          this.situacoesValidacaoUsuario = response.data;
        },
      });
    },
    populaSituacoesUsuarios() {
      apiController.request(apiController.endpoints.getallSituacoespessoaporid, {
        params: { id: this.editedItem.id_pessoa },
        onSuccess: (response) => {
          this.situacoesUsuario = response.data;
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    populaGrupos() {
      apiController.request(apiController.endpoints.getGruposmatriz, {
        onSuccess: (response) => {
          this.grupos = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
      });
    },
    populaSubgrupos(id) {
      apiController.request(apiController.endpoints.getSubgrupos, {
        params: { id },
        onSuccess: (response) => {
          this.subgrupos = response.data;
          if (response.data.erro) this.resultadosAxios.push(response.data);
        },
      });
    },
    validaCPF() {
      const cpf = this.editedItem.cpf;
      const falsos = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999']
      let soma = 0;
      let resto;

      if (cpf == null) return this.$t('candidate.cpfRequired');

      if (cpf.length !== 11) return this.$t('candidate.invalidCpf');

      if (falsos.indexOf(cpf) !== -1) return this.$t('candidate.invalidCpf');

      for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if ((resto == 10) || (resto == 11)) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return this.$t('candidate.invalidCpf');

      soma = 0;
      for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if ((resto == 10) || (resto == 11)) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return this.$t('candidate.invalidCpf');
      return true;
    },
    validaCURP() {
      const curpString = this.editedItem.cpf;
      
      if (curpString == null) return this.$t('candidate.cpfRequired');

      if (curpString.length !== 18) return this.$t('candidate.invalidCpf');

      const isValid = curp.validar(curpString);
      if (!isValid) return this.$t('candidate.invalidCpf');

      return true;
    },
    validaDocumentoIdentidade() {
      // Se não há país selecionado, usa validação de CPF por padrão
      if (!this.editedItem.id_pais) {
        return this.validaCPF();
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(p => p.id_pais === this.editedItem.id_pais);
      
      // Se o país for México (id_pais = 2 ou sigla = 'MX'), valida CURP
      if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
        return this.validaCURP();
      }
      
      // Para Brasil ou outros países, valida CPF
      return this.validaCPF();
    },
    validaCodigoPostalMX() {
      let codigoPostal = this.editedItem.cep;

      if (codigoPostal == null) return this.$t('candidate.postalCodeRequired');

      // Código postal mexicano tem 5 dígitos
      if (codigoPostal.length !== 5) return this.$t('candidate.invalidPostalCode');

      // Deve conter apenas dígitos
      if (!/^\d+$/.test(codigoPostal)) return this.$t('candidate.invalidPostalCode');

      return true;
    },
    validaCEP() {
      // Se não há país selecionado, usa validação de CEP por padrão
      if (!this.editedItem.id_pais) {
        let cep = this.editedItem.cep;
        if (cep == null) return this.$t('candidate.postalCodeRequired');
        if (cep.length !== 8) return this.$t('candidate.invalidPostalCode');
        return true;
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(p => p.id_pais === this.editedItem.id_pais);
      
      // Se o país for México (id_pais = 2 ou sigla = 'MX'), valida código postal mexicano
      if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
        return this.validaCodigoPostalMX();
      }
      
      // Para Brasil ou outros países, valida CEP (8 dígitos)
      let cep = this.editedItem.cep;
      if (cep == null) return this.$t('candidate.postalCodeRequired');
      if (cep.length !== 8) return this.$t('candidate.invalidPostalCode');
      return true;
    },
    /**
     * Trava o campo que veio preenchido do registro de origem na promoção.
     *
     * O que veio vazio (pré-candidato sem sobrenome, endereço externo sem número) continua
     * editável: travar um campo obrigatório que a origem não tinha como preencher deixaria a
     * promoção sem saída. O que veio preenchido é intocável — é o dado já validado na origem.
     */
    campoTravadoPorPromocao(campo) {
      const ehNome = campo === 'nome' || campo === 'sobrenome';
      const travaAtiva = ehNome ? this.promocaoBloqueiaNome : this.promocaoBloqueiaEndereco;
      if (!travaAtiva) return false;
      const valor = this.editedItem[campo];
      return valor != null && String(valor).trim() !== '';
    },
    consultaCEP() {
      // CEP travado pela promoção: a consulta reescreveria o endereço vindo da origem.
      if (this.campoTravadoPorPromocao('cep')) {
        return;
      }
      // Verifica se o país é México - não consulta API brasileira para código postal mexicano
      if (this.editedItem.id_pais) {
        const paisSelecionado = this.paises.find(p => p.id_pais === this.editedItem.id_pais);
        if (paisSelecionado && (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === 'MX')) {
          // Para México, não há consulta automática de endereço por código postal
          this.loadingtext = false;
          return;
        }
      }

      let cep = String(this.editedItem.cep || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        return;
      }

      this.loadingtext = true

      registrarChamadaApiExterna('VIACEP', 'CEP_LOOKUP', 1, this.token);
      axios.get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          if (response.data.erro) {
            this.loadingtext = false
            this.editedItem.cep = "";
            if (!this.campoTravadoPorPromocao('endereco')) this.editedItem.endereco = null;
          } else {
            // Campo travado pela promoção fica como veio da origem.
            const aplica = (campo, valor) => {
              if (!this.campoTravadoPorPromocao(campo)) this.editedItem[campo] = valor;
            };
            aplica('endereco', response.data.logradouro);
            aplica('cidade', response.data.localidade);
            aplica('estado', response.data.uf);
            aplica('bairro', response.data.bairro);
            this.loadingtext = false
          }
        })
        .catch((e) => {
          EventBus.$emit('show-error', { error: e });
          this.loadingtext = false
        });
    },
    /**
     * "Progredir": abre o cadastro de candidato já com o endereço externo preenchido,
     * para o usuário completar os dados da pessoa (nome, documento, cliente, unidade).
     * Reaproveita o formulário e o save() do próprio CRUD — o endereço externo não é
     * consumido nem marcado: continua na aba, podendo virar mais de um candidato.
     */
    /**
     * Situação que o candidato herda ao ser progredido.
     * O endereço externo traz `id_situacao_validacao`, calculado no backend com as
     * mesmas constantes de /validacandidatosbulk — repetir a regra aqui sairia do ar
     * assim que as variáveis de ambiente mudassem. O pré-candidato já guarda a
     * situação em `validacao`, então é só repassar. Sem situação, nada é semeado.
     * Semeia a dimensão de VALIDAÇÃO — não a funcional, que nasce como Ativo.
     */
    buildSituacaoDaValidacao(idSituacao) {
      if (idSituacao == null) return [];
      const situacao = (this.situacoesValidacao || []).find(
        (s) => Number(s.id_situacao_validacao) === Number(idSituacao)
      );
      if (!situacao) return [];
      const agora = new Date();
      return [Object.assign({}, this.defaultSituacaoValidacao, {
        id_situacao_validacao: situacao.id_situacao_validacao,
        nome_situacao_validacao: situacao.nome,
        prioridade: situacao.prioridade,
        dt_inicio_vigencia: DateUtils.getDateSQLFormatted(agora),
        dt_inicio_vigencia_extenso: agora.toLocaleString(),
        dt_fim_vigencia: null,
        dt_fim_vigencia_extenso: null,
        id_usuario_inclusao: this.user ? this.user.id_usuario : null,
        can_delete: 1,
        can_edit: 1,
      })];
    },
    /**
     * "Promover": abre o cadastro de candidato com os dados do pré-candidato.
     * `nome_completo` é uma coluna só, então vira nome + sobrenome pelo primeiro
     * espaço; `pre_candidatos` não guarda estado nem país, que ficam com o padrão
     * do sistema. A situação de validação vem de `validacao`, que já é um
     * id_situacao_validacao.
     */
    progredirPreCandidatoParaCandidato(preCandidato) {
      if (!preCandidato) return;
      const nomeCompleto = String(preCandidato.nome_completo || '').trim();
      const partes = nomeCompleto.split(/\s+/).filter(Boolean);
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem, {
        nome: partes.length ? partes[0] : null,
        sobrenome: partes.length > 1 ? partes.slice(1).join(' ') : null,
        cep: preCandidato.cep,
        endereco: preCandidato.rua,
        numero: preCandidato.numero,
        bairro: preCandidato.bairro,
        cidade: preCandidato.cidade,
        lat: preCandidato.lat,
        lng: preCandidato.lng,
        id_agencia_emprego: preCandidato.id_agencia_emprego,
        id_pre_candidato: preCandidato.id_pre_candidato,
      });
      this.checkCountry();
      this.editedItemUnidadesValidadas = [];
      this.situacoesValidacaoUsuario = this.buildSituacaoDaValidacao(preCandidato.validacao);
      this.pcd = false;
      this.tab = 0;
      this.mainTab = 1;
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.formPessoal) this.$refs.formPessoal.resetValidation();
        if (this.$refs.formEndereco) this.$refs.formEndereco.resetValidation();
      });
    },
    progredirEnderecoParaCandidato(endereco) {
      if (!endereco) return;
      const pais = (this.paises || []).find((p) => p.sigla === endereco.pais);
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem, {
        cep: endereco.cep,
        endereco: endereco.endereco,
        numero: endereco.numero,
        bairro: endereco.bairro,
        cidade: endereco.cidade,
        estado: endereco.estado,
        id_pais: pais ? pais.id_pais : null,
        sigla_pais: endereco.pais,
        lat: endereco.lat,
        lng: endereco.lng,
        id_agencia_emprego: endereco.id_agencia_emprego,
        id_endereco_externo: endereco.id_endereco_externo,
      });
      this.editedItemUnidadesValidadas = [];
      this.situacoesValidacaoUsuario = this.buildSituacaoDaValidacao(endereco.id_situacao_validacao);
      this.pcd = false;
      this.tab = 0;
      // Vai para a aba de candidatos: é onde o registro novo vai aparecer depois de salvo.
      this.mainTab = 0;
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.formPessoal) this.$refs.formPessoal.resetValidation();
        if (this.$refs.formEndereco) this.$refs.formEndereco.resetValidation();
      });
    },
    editItem(item) {
      this.editedIndex = this.candidatos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.pcd = this.editedItem.pcd == 1;
      this.editedItemUnidadesValidadas = Array.isArray(item.unidades_validadas)
        ? item.unidades_validadas.slice()
        : [];
      this.populaSituacoesUsuarios();
      this.populaSituacoesValidacaoUsuarios();
      this.dialog = true;
      this.$nextTick(() => this.syncUnidadeSelect());
      this.loadUnidadesValidadasForEdit(item).then(() => {
        this.$nextTick(() => this.syncUnidadeSelect());
      });
    },
    onUnidadeSelect(val) {
      this.editedItem.id_unidade = val;
      const ref = this.$refs.unidadeSelect;
      if (ref && val != null && ref.selectedItemCache) {
        const cached = ref.selectedItemCache[val];
        if (cached) {
          if (cached.cod_unidade != null) this.editedItem.cod_unidade = cached.cod_unidade;
          if (cached.descricao_unidade != null) {
            this.editedItem.descricao_unidade = cached.descricao_unidade;
          }
        }
      } else if (val == null) {
        this.editedItem.cod_unidade = null;
        this.editedItem.descricao_unidade = null;
      }
    },
    syncUnidadeSelect() {
      const ref = this.$refs.unidadeSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_unidade;
      if (id != null && id !== '') {
        const fromValidated = (this.editedItemUnidadesValidadas || []).find(
          (u) => String(u.id_unidade) === String(id)
        );
        const fromCatalog = (this.unidades || []).find(
          (u) => String(u.id_unidade) === String(id)
        );
        const item = fromValidated || fromCatalog || {
          id_unidade: id,
          cod_unidade: this.editedItem.cod_unidade,
          descricao_unidade: this.editedItem.descricao_unidade,
        };
        ref.cacheSelectedItems([item], 'id_unidade');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.messageConfirmButton = this.$t('button.delete');
      this.messageDismissButton = this.$t('button.cancel');
      this.mensagemdialog = this.$t('candidate.confirmDelete', { name: this.deletedItem.nome_completo });
      this.confirmDialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.disableLogin = false,
          this.show1 = false,
          this.show2 = false,
          this.situacoesUsuario = [];
          this.situacoesValidacaoUsuario = [];
        this.editedItemUnidadesValidadas = [];
        this.tab = 0;
        this.pcd = false;
        this.checkCountry();
        if (this.$refs.unidadeSelect && typeof this.$refs.unidadeSelect.resetData === 'function') {
          this.$refs.unidadeSelect.resetData();
        }
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    confirm() {
      if (this.reservaConfirmPending) {
        this.reservaConfirmPending = false;
        this.confirmDialog = false;
        this.mensagemdialog = "";
        this.criarReserva(true);
        return;
      }
      if (this.promoverDialog) {
        this.promoverCandidatos();
      } else {
        this.deleteFromDatabase();
      }
    },
    closeConfirmDialog() {
      this.deletedItem = Object.assign({}, this.defaultItem);
      this.confirmDialog = false;
      this.mensagemdialog = "";
      this.promoverDialog = false;
      this.reservaConfirmPending = false;
    },
    closeDialogSituacoes() {
      this.dialogSituacoes = false;
      this.$nextTick(() => {
        this.editedSituacao = Object.assign({}, this.defaultSituacao);
        this.editingSituacao = false;
        this.situacoesUsuario = [];
        this.editedSituacaoValidacao = Object.assign({}, this.defaultSituacaoValidacao);
        this.editingSituacaoValidacao = false;
        this.situacoesValidacaoUsuario = [];
      })
    },
    async save() {
      this.$refs.formPessoal.validate();
      this.formEnderecoValidado = !this.editedItem.cep || this.$refs.formEndereco.validate();

      if (this.formPessoalValidado && this.formEnderecoValidado) {
        this.loadingSave = true;
        this.loadingMessage = this.$t('candidate.loadingSave');

        this.editedItem.ativo = 1;
        this.editedItem.pcd = this.pcd ? 1 : 0;

        this.operacao = 0;
        try {
          const response = await apiController.request(apiController.endpoints.insertCandidato, {
            data: this.editedItem,
            silent: true,
          });
          this.loadingSave = false;
          if (response.data.erro) {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
            return this.updateTable();
          }
          const situacaoError = (await this.saveSituacoesOnDatabase(response.data.idpessoa))
            || (await this.saveSituacoesValidacaoOnDatabase(response.data.idpessoa));
          if (situacaoError) {
            EventBus.$emit('show-alert', { mensagem: situacaoError.mensagem, tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' });
          }
          return this.updateTable();
        } catch (e) {
          this.loadingSave = false;
          EventBus.$emit('show-error', { error: e });
        }
      }
    },
    async saveSituacoesOnDatabase(idpessoa) {
      if (this.situacoesUsuario.length === 0) {
        return null;
      }

      let situacaoError = null;
      this.loadingSaveSituacoes = true;
      try {
        await Promise.all(this.situacoesUsuario.map(async (s) => {
          if (s.id_situacao_pessoa) {
            const response = await apiController.request(apiController.endpoints.updateSituacaopessoa, {
              data: s,
              silent: true,
            });
            if (response.data.erro && !situacaoError) {
              situacaoError = response.data;
            }
            return;
          }

          s.id_pessoa = idpessoa;
          const response = await apiController.request(apiController.endpoints.insertSituacaopessoa, {
            data: s,
            silent: true,
          });
          if (response.data.erro && !situacaoError) {
            situacaoError = response.data;
          }
        }));
        return situacaoError;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
        throw e;
      } finally {
        this.loadingSaveSituacoes = false;
      }
    },
    async saveBulk() {
      this.loadingSave = true;
      this.resultadosAxios = [];
      if (this.resultCSV.length > 0) {
        try {
          await Promise.all(this.resultCSV.map(async (cand) => {
            const payload = {
              ...cand,
              pcd: cand.pcd == null || cand.pcd === "" ? 0 : cand.pcd,
            };
            try {
              const response = await apiController.request(apiController.endpoints.insertCandidato, {
                data: payload,
                silent: true,
              });
              this.resultadosAxios.push(response.data);
            } catch (e) {
              EventBus.$emit('show-error', { error: e });
            }
          }));
          this.loadingSave = false;
          this.uploadResultDialog = false;
          this.updateTable();
        } catch (e) {
          this.loadingSave = false;
          EventBus.$emit('show-error', { error: e });
        }
      }
    },
    saveSituacaoValidacao() {
      this.$refs.formSituacoesValidacao.validate();
      if (!this.formSituacoesValidacaoValidado) return;
      this.editedSituacaoValidacao.id_situacao_validacao = this.novaSituacaoValidacao.id_situacao_validacao;
      this.editedSituacaoValidacao.nome_situacao_validacao = this.novaSituacaoValidacao.nome;
      this.editedSituacaoValidacao.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(this.dtInicioVigenciaSituacaoValidacao);
      this.editedSituacaoValidacao.dt_inicio_vigencia_extenso = this.dtInicioVigenciaSituacaoValidacao.toLocaleString();
      this.editedSituacaoValidacao.dt_fim_vigencia = DateUtils.getDateSQLFormatted(this.dtFimVigenciaSituacaoValidacao);
      this.editedSituacaoValidacao.dt_fim_vigencia_extenso = this.dtFimVigenciaSituacaoValidacao
        ? this.dtFimVigenciaSituacaoValidacao.toLocaleString()
        : null;
      this.editedSituacaoValidacao.prioridade = this.novaSituacaoValidacao.prioridade;
      this.editedSituacaoValidacao.id_usuario_inclusao = this.user.id_usuario;
      this.editedSituacaoValidacao.can_delete = 1;
      this.editedSituacaoValidacao.can_edit = 1;
      if (this.editingSituacaoValidacao) {
        this.editedSituacaoValidacao.dt_ultima_alteracao = DateUtils.getDateSQLFormatted(new Date());
        this.editedSituacaoValidacao.id_usuario_ultima_alteracao = this.user.id_usuario;
        this.situacoesValidacaoUsuario.splice(this.editedSituacaoValidacaoIndex);
      }
      this.situacoesValidacaoUsuario.push(this.editedSituacaoValidacao);
      this.editedSituacaoValidacao = Object.assign({}, this.defaultSituacaoValidacao);

      this.$nextTick(() => {
        this.dtInicioVigenciaSituacaoValidacao = null;
        this.dtFimVigenciaSituacaoValidacao = null;
        this.novaSituacaoValidacao = null;
        this.editingSituacaoValidacao = false;
        this.editedSituacaoValidacaoIndex = -1;
        this.$refs.formSituacoesValidacao.reset();
      });
    },
    editSituacaoValidacao(item, i) {
      this.novaSituacaoValidacao = this.situacoesValidacao.find(
        (s) => item.id_situacao_validacao == s.id_situacao_validacao
      );
      this.dtInicioVigenciaSituacaoValidacao = new Date(item.dt_inicio_vigencia);
      this.dtFimVigenciaSituacaoValidacao = item.dt_fim_vigencia ? new Date(item.dt_fim_vigencia) : null;
      this.editedSituacaoValidacao = Object.assign({}, item);
      this.editingSituacaoValidacao = true;
      this.editedSituacaoValidacaoIndex = i;
    },
    deleteSituacaoValidacao(item, i) {
      this.situacoesValidacaoUsuario.splice(i, 1);
    },
    /** Espelha saveSituacoesOnDatabase na dimensão de validação. */
    async saveSituacoesValidacaoOnDatabase(idpessoa) {
      if (this.situacoesValidacaoUsuario.length === 0) {
        return null;
      }
      let situacaoError = null;
      this.loadingSaveSituacoesValidacao = true;
      try {
        await Promise.all(this.situacoesValidacaoUsuario.map(async (s) => {
          if (s.id_situacao_validacao_pessoa) {
            const response = await apiController.request(apiController.endpoints.updateSituacaovalidacaopessoa, {
              data: s,
              silent: true,
            });
            if (response.data.erro && !situacaoError) {
              situacaoError = response.data;
            }
            return;
          }
          s.id_pessoa = idpessoa;
          const response = await apiController.request(apiController.endpoints.insertSituacaovalidacaopessoa, {
            data: s,
            silent: true,
          });
          if (response.data.erro && !situacaoError) {
            situacaoError = response.data;
          }
        }));
        return situacaoError;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
        return null;
      } finally {
        this.loadingSaveSituacoesValidacao = false;
      }
    },
    saveSituacao() {
      this.$refs.formSituacoes.validate();
      if (this.formSituacoesValidado) {
        this.editedSituacao.id_situacao = this.novaSituacao.id_situacao;
        this.editedSituacao.nome_situacao = this.novaSituacao.nome;
        this.editedSituacao.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(this.dtInicioVigenciaSituacao);
        this.editedSituacao.dt_inicio_vigencia_extenso = this.dtInicioVigenciaSituacao.toLocaleString();
        this.editedSituacao.dt_fim_vigencia = DateUtils.getDateSQLFormatted(this.dtFimVigenciaSituacao);
        this.editedSituacao.dt_fim_vigencia_extenso = this.dtFimVigenciaSituacao ? this.dtFimVigenciaSituacao.toLocaleString() : null;
        this.editedSituacao.prioridade = this.novaSituacao.prioridade;
        this.editedSituacao.id_usuario_inclusao = this.user.id_usuario;
        this.editedSituacao.can_delete = 1;
        this.editedSituacao.can_edit = 1;
        if (this.editingSituacao) {
          this.editedSituacao.dt_ultima_alteracao = DateUtils.getDateSQLFormatted(new Date());
          this.editedSituacao.id_usuario_ultima_alteracao = this.user.id_usuario;
          this.situacoesUsuario.splice(this.editedSituacaoIndex);
        }
        this.situacoesUsuario.push(this.editedSituacao);
        this.editedSituacao = Object.assign({}, this.defaultSituacao);

        this.$nextTick(() => {
          this.dtInicioVigenciaSituacao = null;
          this.dtFimVigenciaSituacao = null;
          this.novaSituacao = null;
          this.editingSituacao = false;
          this.editedSituacaoIndex = -1;
          this.$refs.formSituacoes.reset();
        })
      }
    },
    editSituacao(item, i) {
      this.novaSituacao = this.situacoes.find((s) => item.id_situacao == s.id_situacao);
      this.dtInicioVigenciaSituacao = new Date(item.dt_inicio_vigencia);
      this.dtFimVigenciaSituacao = item.dt_fim_vigencia ? new Date(item.dt_fim_vigencia) : null;
      this.editedSituacao = Object.assign({}, item);
      this.editingSituacao = true;
      this.editedSituacaoIndex = i;
    },
    deleteFromDatabase() {
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deletePessoa, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.resultadosAxios = [response.data];
          this.updateTable();
        },
      });
    },
    updateTable() {
      this.close();
      this.closeConfirmDialog();
      return this.populaCandidatos().then(() => {
        if (this.$refs.alertasAxios) {
          this.$refs.alertasAxios.showAlerts(this.resultadosAxios);
        }
      });
    },
    onCsvUploadDone(data) {
      this.mensagemUpload = data.error
        ? this.$t('system.messages.fileProcessedError')
        : this.$t('system.messages.fileProcessedSuccess');
      this.fimProcesso = true;
      this.arquivoLog = data.arqlog;
      this.resultCSV = data.result || [];
      this.showSaveButton = !data.error;
      this.uploadResultDialog = true;
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog));
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    cpfChanged() {

    },
    downloadQrCode() {
      apiController.request(
        {
          url: `/api/v1.0/downloadqrcode/${this.editedItem.qrcode_no}/${this.editedItem.id_pessoa}`,
          method: "GET",
        },
        {
          config: {
            responseType: "blob",
            headers: { "x-access-token": this.token },
          },
          onSuccess: (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.editedItem.qrcode_no + "-qr.png"); //or any other extension
            document.body.appendChild(link);
            link.click();
          },
          onError: (e) => {
            EventBus.$emit('show-error', { error: e });
          }
        }
      );
    },
    getNomeCompletoFormatado(nome) {
      if (!nome) {
        return null;
      }

      let fNome = ""
      nome.split(" ").forEach((s) => {
        fNome += s.charAt(0).toUpperCase() + s.substring(1) + " ";
      });
      return fNome;
    },
    /**
     * Com menos de 30 itens a API valida na própria requisição e devolve o resultado; a partir
     * disso enfileira no worker do scheduler (202) e o resultado chega pelo acompanhamento.
     */
    atualizaRotasCandidatos(candidatos) {
      const lista = Array.isArray(candidatos)
        ? candidatos.filter((c) => c != null && c.id_pessoa != null)
        : [];
      if (lista.length === 0) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('candidate.validateNoSelection'),
        });
        return;
      }
      this.loadingtable = true;
      this.resultadosAxios = [];
      const timeoutMs = Math.max(180000, 90000 * Math.ceil(lista.length / 4));
      return (async () => {
        try {
          const response = await apiController.request(apiController.endpoints.validaCandidatosbulk, {
            data: {
              candidatos: lista.map((c) => ({
                ...c,
                // Mantém id_unidade no upsert; a API ignora na validação via ignoreCandidateUnit.
                pessoaIdUnidade: c.id_unidade,
                ignoreCandidateUnit: true,
              })),
              checkCapacity: this.validacaoCheckCapacity,
              considerarReservas: this.validacaoConsiderarReservas,
              tempoMaximoPermanenciaLinha: this.tempoMaximoPermanenciaPayload,
              considerarTempoPermanencia: this.validacaoConsiderarTempoPermanencia,
              maxLinhasRetorno: this.maxLinhasRetornoPayload,
              calcularCaminhada: this.validacaoCalcularCaminhada,
              ignoreCandidateUnit: true,
            },
            config: { timeout: timeoutMs },
            silent: true,
          });
          // Acima do limite da rota o lote é enfileirado (202): o POST volta na hora e o
          // resultado chega pelo scheduler, então a conexão não fica presa até o timeout.
          const data = await this.consumirRespostaValidacaoBulk(response, lista.length);
          const unitsByPerson = this.applyBulkValidationResults(lista, data);
          const selectionItems = (this.unidadeValidadaItems || []).slice();
          this.unidadeValidadaItems = [];
          await this.updateTable();
          if (unitsByPerson && typeof unitsByPerson === 'object') {
            Object.keys(unitsByPerson).forEach((id) => {
              const row = this.candidatos.find((c) => String(c.id_pessoa) === String(id));
              if (row) {
                this.$set(row, 'unidades_validadas', unitsByPerson[id]);
              }
            });
          }
          if (selectionItems.length) {
            this.unidadeValidadaItems = selectionItems;
            this.unidadeValidadaDialog = true;
            this.$nextTick(() => {
              selectionItems.forEach((item) => {
                if (item.id_linha_ida) this.ensureCercasForLinha(item.id_linha_ida, item, 'ida');
                if (item.id_linha_volta) this.ensureCercasForLinha(item.id_linha_volta, item, 'volta');
              });
            });
          }
        } catch (e) {
          const msg =
            e && e.code === 'ECONNABORTED'
              ? this.$t('candidate.validationRequestTimeout')
              : (e && e.message) || String(e);
          this.resultadosAxios.push({ erro: true, mensagem: msg });
          EventBus.$emit('show-error', { error: e });
        } finally {
          this.encerrarValidacaoScheduler();
          this.loadingtable = false;
        }
      })();
    },
    /**
     * Consulta o processo no scheduler. Fica no componente, e não no mixin, porque o gerador
     * do permissions.manifest.json só varre arquivos .vue: uma chamada a apiController.endpoints
     * escondida num .js faria a permissão do endpoint sumir desta tela.
     */
    buscarProcessoScheduler(idProcesso) {
      return apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
        data: { id_processo: idProcesso },
        config: { timeout: 30000 },
        silent: true,
      });
    },
    /**
     * Manda a API gravar o resultado do processo (o worker Python só valida) e devolve os
     * results[] já no formato da resposta síncrona. Fica no componente, e não no mixin, porque
     * o gerador do permissions.manifest.json só varre arquivos .vue.
     */
    aplicarValidacaoScheduler(idProcesso) {
      return apiController.request(apiController.endpoints.aplicaValidacaobulk, {
        data: { id_processo: idProcesso },
        config: { timeout: 300000 },
        silent: true,
      });
    },
    resolveCandidateValidationDetail(r) {
      if (r.validation && r.validation.message) {
        return r.validation.message;
      }
      return r.erro || r.situacao_update_error || this.$t('candidate.validationErrorGeneric');
    },
    applyBulkValidationResults(lista, data) {
      const results = (data && data.results) || [];
      const selectionItems = [];
      const unitsByPerson = {};
      for (let i = 0; i < results.length; i++) {
        const r = results[i];
        const candidato =
          lista.find((c) => r.id_pessoa != null && String(c.id_pessoa) === String(r.id_pessoa)) ||
          lista[i] ||
          {};
        const who = candidato.nome_completo || r.cpf || r.id_pessoa || '';
        const rowFailed =
          (r.erro && r.upsert_action !== 'skipped') || r.situacao_update_ok === false;

        if (rowFailed) {
          const detail = this.resolveCandidateValidationDetail(r);
          this.resultadosAxios.push({
            erro: true,
            mensagem: who ? `${who}: ${detail}` : String(detail),
          });
        } else if (r.validation && r.validation.message) {
          this.resultadosAxios.push({
            erro: false,
            mensagem: who ? `${who}: ${r.validation.message}` : r.validation.message,
          });
        } else if (r.upsert_action === 'skipped') {
          const detail = this.resolveCandidateValidationDetail(r);
          this.resultadosAxios.push({
            erro: true,
            mensagem: who ? `${who}: ${detail}` : String(detail),
          });
        }

        const vu = r.validationUnit;
        if (vu && vu.unitUpdateMessage) {
          this.resultadosAxios.push({
            erro: !!vu.unitUpdateError,
            mensagem: who ? `${who}: ${vu.unitUpdateMessage}` : vu.unitUpdateMessage,
          });
        }

        const usefulUnits = this.normalizeValidationUnits(r.validationUnits);
        if (r.id_pessoa != null && usefulUnits.length) {
          unitsByPerson[r.id_pessoa] = usefulUnits;
          candidato.unidades_validadas = usefulUnits;
        }

        if (vu && vu.unitUpdated && r.id_pessoa != null) {
          const idUnit = vu.id_unidade != null ? vu.id_unidade : vu.idUnit;
          candidato.id_unidade = idUnit;
        }

        if (
          r.needsUnitSelection &&
          usefulUnits.length > 1 &&
          r.id_pessoa != null &&
          !rowFailed
        ) {
          selectionItems.push(this.buildUnidadeValidadaRow(candidato, usefulUnits, vu));
        }
      }
      if (data && data.mensagem) {
        this.resultadosAxios.push({
          erro: !!data.erro,
          mensagem: String(data.mensagem),
        });
      }
      this.resultadosAxios.push({
        erro: false,
        mensagem: this.$t('candidate.allValidationsFinished'),
      });
      this.unidadeValidadaItems = selectionItems;
      return unitsByPerson;
    },
    buildUnidadeValidadaRow(candidato, usefulUnits, vu) {
      const currentUnit =
        candidato.id_unidade != null && candidato.id_unidade !== ''
          ? candidato.id_unidade
          : candidato.pessoaIdUnidade;
      const currentInUseful = usefulUnits.find(
        (u) => String(u.id_unidade) === String(currentUnit)
      );
      const selectedId =
        (currentInUseful && currentInUseful.id_unidade) ||
        (vu && (vu.id_unidade != null ? vu.id_unidade : vu.idUnit)) ||
        usefulUnits[0].id_unidade;
      const selectedUnit = usefulUnits.find((u) => String(u.id_unidade) === String(selectedId))
        || usefulUnits[0];
      const bestLine = this.pickBestLinhaFromUnit(selectedUnit);
      return {
        id_pessoa: candidato.id_pessoa,
        nome: candidato.nome_completo || candidato.nome || '',
        cpf: candidato.cpf || '',
        id_unidade: selectedId,
        unidades_disponiveis: usefulUnits,
        id_linha_ida: bestLine ? bestLine.id_linha : null,
        id_linha_volta: bestLine ? bestLine.id_linha : null,
        id_cerca_embarque: bestLine ? bestLine.id_melhor_cerca : null,
        id_cerca_desembarque: bestLine ? bestLine.id_melhor_cerca : null,
      };
    },
    pickBestLinhaFromUnit(unit) {
      const lines = (unit && Array.isArray(unit.linhas_validadas)) ? unit.linhas_validadas : [];
      if (!lines.length) return null;
      const ranked = lines.slice().sort((a, b) => {
        const rank = (v) => {
          const n = Number(v);
          if (n === 1) return 3;
          if (n === 2) return 2;
          if (n === 3) return 1;
          return 0;
        };
        const rd = rank(b.valido) - rank(a.valido);
        if (rd !== 0) return rd;
        const da = a.distancia != null ? Number(a.distancia) : Number.POSITIVE_INFINITY;
        const db = b.distancia != null ? Number(b.distancia) : Number.POSITIVE_INFINITY;
        return da - db;
      });
      return ranked[0] || null;
    },
    normalizeValidationUnits(units) {
      const list = Array.isArray(units) ? units : [];
      const hasUsefulFlag = list.some((u) => u && u.useful === true);
      const source = hasUsefulFlag
        ? list.filter((u) => u && u.useful === true)
        : list.filter((u) => u && (u.id_unidade != null || u.idUnit != null));
      const seen = new Set();
      const out = [];
      for (const u of source) {
        const id = u.id_unidade != null ? u.id_unidade : u.idUnit;
        if (id == null) continue;
        const key = String(id);
        if (seen.has(key)) continue;
        seen.add(key);
        const fromCatalog = (this.unidades || []).find((x) => String(x.id_unidade) === key);
        out.push({
          id_unidade: id,
          cod_unidade: u.cod_unidade || (fromCatalog && fromCatalog.cod_unidade) || null,
          descricao_unidade:
            u.descricao_unidade ||
            u.unitDisplayName ||
            (fromCatalog && fromCatalog.descricao_unidade) ||
            null,
          linhas_validadas: Array.isArray(u.linhas_validadas) ? u.linhas_validadas : [],
          bestFences: Array.isArray(u.bestFences) ? u.bestFences : [],
        });
      }
      return out;
    },
    unidadeSelectText(item) {
      if (!item) return '';
      const cod = item.cod_unidade != null ? String(item.cod_unidade).trim() : '';
      const desc = item.descricao_unidade != null ? String(item.descricao_unidade).trim() : '';
      if (cod && desc) return `${cod} — ${desc}`;
      return desc || cod || String(item.id_unidade != null ? item.id_unidade : '');
    },
    linhaLabel(line) {
      if (!line) return '';
      const cod = line.cod_linha != null ? String(line.cod_linha).trim() : '';
      const nome = line.nome_linha != null ? String(line.nome_linha).trim() : '';
      if (cod && nome) return `${cod} — ${nome}`;
      return nome || cod || String(line.id_linha != null ? line.id_linha : '');
    },
    linhasForUnidadeItem(item) {
      if (!item || item.id_unidade == null) return [];
      const unit = (item.unidades_disponiveis || []).find(
        (u) => String(u.id_unidade) === String(item.id_unidade)
      );
      return (unit && Array.isArray(unit.linhas_validadas)) ? unit.linhas_validadas : [];
    },
    cercasForLinha(idLinha) {
      if (idLinha == null || idLinha === '') return [];
      const list = this.unidadeValidadaFencesByLine[String(idLinha)];
      return Array.isArray(list) ? list : [];
    },
    onUnidadeValidadaUnitChange(item) {
      if (!item) return;
      const best = this.pickBestLinhaFromUnit(
        (item.unidades_disponiveis || []).find(
          (u) => String(u.id_unidade) === String(item.id_unidade)
        )
      );
      item.id_linha_ida = best ? best.id_linha : null;
      item.id_linha_volta = best ? best.id_linha : null;
      item.id_cerca_embarque = best ? best.id_melhor_cerca : null;
      item.id_cerca_desembarque = best ? best.id_melhor_cerca : null;
      if (item.id_linha_ida) this.ensureCercasForLinha(item.id_linha_ida, item, 'ida');
      if (item.id_linha_volta) this.ensureCercasForLinha(item.id_linha_volta, item, 'volta');
    },
    onUnidadeValidadaLinhaChange(item, sense) {
      if (!item) return;
      if (sense === 'ida') {
        item.id_cerca_embarque = null;
        if (item.id_linha_ida) {
          this.ensureCercasForLinha(item.id_linha_ida, item, 'ida');
        }
      } else {
        item.id_cerca_desembarque = null;
        if (item.id_linha_volta) {
          this.ensureCercasForLinha(item.id_linha_volta, item, 'volta');
        }
      }
    },
    async ensureCercasForLinha(idLinha, item, sense) {
      const key = String(idLinha);
      if (!this.unidadeValidadaFencesByLine[key]) {
        try {
          const response = await apiController.request(apiController.endpoints.getCercasporlinha, {
            data: [idLinha],
            silent: true,
          });
          const rows = Array.isArray(response.data) ? response.data : [];
          const fences = rows.filter((c) => {
            const tipo = c && c.id_tipo_cerca != null ? Number(c.id_tipo_cerca) : null;
            return tipo !== 1 && tipo !== 4;
          });
          this.$set(this.unidadeValidadaFencesByLine, key, fences);
        } catch (e) {
          this.$set(this.unidadeValidadaFencesByLine, key, []);
        }
      }
      if (!item) return;
      const lines = this.linhasForUnidadeItem(item);
      const lineMeta = lines.find((l) => String(l.id_linha) === key);
      const preferred = lineMeta && lineMeta.id_melhor_cerca != null
        ? lineMeta.id_melhor_cerca
        : null;
      const fences = this.cercasForLinha(idLinha);
      const hasPreferred = preferred != null
        && fences.some((f) => String(f.id_cerca) === String(preferred));
      if (sense === 'ida') {
        if (item.id_cerca_embarque == null && hasPreferred) {
          item.id_cerca_embarque = preferred;
        } else if (
          item.id_cerca_embarque != null
          && !fences.some((f) => String(f.id_cerca) === String(item.id_cerca_embarque))
        ) {
          item.id_cerca_embarque = hasPreferred ? preferred : null;
        }
      } else if (sense === 'volta') {
        if (item.id_cerca_desembarque == null && hasPreferred) {
          item.id_cerca_desembarque = preferred;
        } else if (
          item.id_cerca_desembarque != null
          && !fences.some((f) => String(f.id_cerca) === String(item.id_cerca_desembarque))
        ) {
          item.id_cerca_desembarque = hasPreferred ? preferred : null;
        }
      }
    },
    skipUnidadeValidadaDialog() {
      this.unidadeValidadaDialog = false;
      this.unidadeValidadaItems = [];
      if (this.promoverAposUnidade) this.abrirDialogoPromocao();
    },
    async confirmUnidadeValidadaTable() {
      const items = (this.unidadeValidadaItems || []).filter(
        (i) => i && i.id_pessoa != null && i.id_unidade != null && i.id_unidade !== ''
      );
      if (!items.length) return;
      this.unidadeValidadaSaving = true;
      try {
        const unitUpdates = items.map((i) => ({
          id_pessoa: i.id_pessoa,
          id_unidade: i.id_unidade,
        }));
        const unitRes = await apiController.request(apiController.endpoints.aplicaUnidadespessoas, {
          data: { updates: unitUpdates },
          silent: true,
        });
        if (unitRes.data && unitRes.data.erro) {
          this.resultadosAxios.push({
            erro: true,
            mensagem: unitRes.data.mensagem || this.$t('candidate.unitAssociateError'),
          });
          return;
        }

        const passageiros = items.map((i) => ({
          id_pessoa: i.id_pessoa,
          id_linha_ida: i.id_linha_ida || null,
          id_linha_volta: i.id_linha_volta || null,
          id_cerca_embarque: i.id_cerca_embarque || null,
          id_cerca_desembarque: i.id_cerca_desembarque || null,
        }));
        const hasLines = passageiros.some(
          (p) => p.id_linha_ida != null || p.id_linha_volta != null
        );
        if (hasLines) {
          const allocRes = await apiController.request(apiController.endpoints.alocaPessoasemlinhas, {
            data: { passageiros },
            silent: true,
          });
          if (allocRes.data && allocRes.data.erro) {
            this.resultadosAxios.push({
              erro: true,
              mensagem: allocRes.data.mensagem || this.$t('candidate.unitAssociateError'),
            });
            return;
          }
        }

        items.forEach((i) => {
          const row = this.candidatos.find((c) => String(c.id_pessoa) === String(i.id_pessoa));
          const unit = (i.unidades_disponiveis || []).find(
            (u) => String(u.id_unidade) === String(i.id_unidade)
          );
          if (row) {
            row.id_unidade = i.id_unidade;
            if (unit) {
              if (unit.cod_unidade != null) row.cod_unidade = unit.cod_unidade;
              if (unit.descricao_unidade != null) row.descricao_unidade = unit.descricao_unidade;
            }
          }
          const label = this.unidadeSelectText(unit) || String(i.id_unidade);
          this.resultadosAxios.push({
            erro: false,
            mensagem: `${i.nome || i.id_pessoa}: ${this.$t('candidate.unitAssociatedTo', { unit: label })}`,
          });
        });
        // A promoção reenvia os selecionados: mantém neles a unidade recém-associada.
        items.forEach((i) => {
          const sel = (this.candidatosSelected || []).find((c) => String(c.id_pessoa) === String(i.id_pessoa));
          if (sel) sel.id_unidade = i.id_unidade;
        });
        this.unidadeValidadaDialog = false;
        this.unidadeValidadaItems = [];
        await this.updateTable();
        if (this.promoverAposUnidade) this.abrirDialogoPromocao();
      } catch (e) {
        const detail =
          (e && e.response && e.response.data && (e.response.data.mensagem || e.response.data.message))
          || (e && e.message)
          || this.$t('candidate.unitAssociateError');
        EventBus.$emit('show-error', { error: e });
        this.resultadosAxios.push({
          erro: true,
          mensagem: String(detail),
        });
      } finally {
        this.unidadeValidadaSaving = false;
        if (this.$refs.alertasAxios) {
          this.$refs.alertasAxios.showAlerts(this.resultadosAxios);
        }
      }
    },
    async loadUnidadesValidadasForEdit(item) {
      if (!item || item.id_pessoa == null) {
        this.editedItemUnidadesValidadas = [];
        return;
      }
      if (Array.isArray(item.unidades_validadas) && item.unidades_validadas.length > 1) {
        this.editedItemUnidadesValidadas = item.unidades_validadas.slice();
        return;
      }
      try {
        const response = await apiController.request(
          apiController.endpoints.getEnderecosvalidadospessoa,
          {
            data: { ids: [item.id_pessoa] },
            silent: true,
          }
        );
        const rows = Array.isArray(response.data) ? response.data : [];
        const useful = rows.filter((r) => [1, 2, 3].includes(Number(r.valido)));
        const seen = new Set();
        const units = [];
        for (const r of useful) {
          if (r.id_unidade == null || r.id_unidade === '') continue;
          const key = String(r.id_unidade);
          if (seen.has(key)) continue;
          seen.add(key);
          const fromCatalog = (this.unidades || []).find((u) => String(u.id_unidade) === key);
          units.push({
            id_unidade: r.id_unidade,
            cod_unidade: r.cod_unidade || (fromCatalog && fromCatalog.cod_unidade) || null,
            descricao_unidade:
              r.descricao_unidade || (fromCatalog && fromCatalog.descricao_unidade) || null,
          });
        }
        this.editedItemUnidadesValidadas = units;
        const tableRow = this.candidatos.find(
          (c) => String(c.id_pessoa) === String(item.id_pessoa)
        );
        if (tableRow && units.length) {
          this.$set(tableRow, 'unidades_validadas', units);
        }
      } catch (e) {
        if (!this.editedItemUnidadesValidadas.length && Array.isArray(item.unidades_validadas)) {
          this.editedItemUnidadesValidadas = item.unidades_validadas.slice();
        }
      }
    },
    async atualizaSituacao(idpessoa, idsituacao, timeoutMs, rethrow) {
      const payload = {
        id_pessoa: idpessoa,
        id_situacao_validacao: idsituacao,
        id_usuario: this.user.id_usuario,
      };
      const config = {};
      if (timeoutMs != null && timeoutMs > 0) {
        config.timeout = timeoutMs;
      }
      try {
        const response = await apiController.request(apiController.endpoints.alteraSituacaovalidacaoativapessoa, {
          data: payload,
          config,
          silent: true,
        });
        const d = response.data;
        this.resultadosAxios.push({
          erro: !!d.erro,
          mensagem:
            d.mensagem != null && d.mensagem !== ''
              ? String(d.mensagem)
              : d.erro
                ? 'Erro'
                : '',
        });
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
        if (rethrow) {
          throw e;
        }
      }
    },
    /**
     * Botão Promover: antes do diálogo de promoção, abre o de unidade/linha com as linhas gravadas
     * na última validação de cada selecionado. Quem não tem linha validada segue direto.
     */
    async openPromoverDialog() {
      if (this.promoverLoading) return;
      const selecionados = (this.candidatosSelected || []).filter((c) => c && c.id_pessoa != null);
      let items = [];
      if (selecionados.length) {
        this.promoverLoading = true;
        try {
          const unitsByPerson = await this.loadUnidadesValidadasParaAlocacao(
            selecionados.map((c) => c.id_pessoa)
          );
          items = selecionados
            .filter((c) => (unitsByPerson[String(c.id_pessoa)] || []).length)
            .map((c) => this.buildUnidadeValidadaRow(c, unitsByPerson[String(c.id_pessoa)], null));
        } catch (e) {
          EventBus.$emit('show-error', { error: e });
        } finally {
          this.promoverLoading = false;
        }
      }
      if (!items.length) {
        this.abrirDialogoPromocao();
        return;
      }
      this.promoverAposUnidade = true;
      this.unidadeValidadaItems = items;
      this.unidadeValidadaDialog = true;
      this.$nextTick(() => {
        items.forEach((item) => {
          if (item.id_linha_ida) this.ensureCercasForLinha(item.id_linha_ida, item, 'ida');
          if (item.id_linha_volta) this.ensureCercasForLinha(item.id_linha_volta, item, 'volta');
        });
      });
    },
    abrirDialogoPromocao() {
      this.promoverAposUnidade = false;
      this.turnoSelected = null;
      this.promoverDialog = true;
    },
    /**
     * Unidades que atendem cada pessoa, com todas as linhas possíveis, no formato de
     * `unidades_disponiveis` do diálogo. Usa as linhas da última validação
     * (pessoas_enderecos_validados_linhas); quem foi validado antes delas existirem cai na melhor
     * linha de cada turno da última validação gravada.
     */
    async loadUnidadesValidadasParaAlocacao(ids) {
      const response = await apiController.request(apiController.endpoints.getEnderecosvalidadospessoa, {
        data: { ids, linhas: true },
        silent: true,
      });
      let rows = (Array.isArray(response.data) ? response.data : []).map((r) => ({
        id_pessoa: r.id_pessoa,
        id_unidade: r.id_unidade,
        cod_unidade: r.cod_unidade,
        descricao_unidade: r.descricao_unidade,
        id_linha: r.id_linha,
        cod_linha: r.cod_linha,
        nome_linha: r.nome_linha,
        id_cerca: r.id_cerca,
        cod_cerca: r.cod_cerca,
        nome_cerca: r.nome_cerca,
        distancia: r.distancia,
        valido: r.valido,
      }));
      const comLinhas = new Set(rows.map((r) => String(r.id_pessoa)));
      const semLinhas = ids.filter((id) => !comLinhas.has(String(id)));
      if (semLinhas.length) {
        const legado = await apiController.request(apiController.endpoints.getEnderecosvalidadospessoa, {
          data: { ids: semLinhas },
          silent: true,
        });
        // Só a última validação de cada turno: a tabela guarda o histórico inteiro.
        const ultimaPorTurno = new Map();
        (Array.isArray(legado.data) ? legado.data : []).forEach((r) => {
          const key = `${r.id_pessoa}|${r.id_turno}`;
          const prev = ultimaPorTurno.get(key);
          if (!prev || String(r.dt_validacao) > String(prev.dt_validacao)) ultimaPorTurno.set(key, r);
        });
        rows = rows.concat(Array.from(ultimaPorTurno.values()).map((r) => ({
          id_pessoa: r.id_pessoa,
          id_unidade: r.id_unidade,
          cod_unidade: r.cod_unidade,
          descricao_unidade: r.descricao_unidade,
          id_linha: r.id_melhor_linha,
          cod_linha: r.cod_linha,
          nome_linha: r.nome_linha,
          id_cerca: r.id_melhor_cerca,
          cod_cerca: r.cod_cerca,
          nome_cerca: r.nome_cerca,
          distancia: r.distancia,
          valido: r.valido,
        })));
      }

      const out = {};
      rows.forEach((r) => {
        if (r.id_linha == null || r.id_unidade == null || ![1, 2, 3].includes(Number(r.valido))) return;
        const pessoaKey = String(r.id_pessoa);
        const units = out[pessoaKey] || (out[pessoaKey] = []);
        let unit = units.find((u) => String(u.id_unidade) === String(r.id_unidade));
        if (!unit) {
          const fromCatalog = (this.unidades || []).find((u) => String(u.id_unidade) === String(r.id_unidade));
          unit = {
            id_unidade: r.id_unidade,
            cod_unidade: r.cod_unidade || (fromCatalog && fromCatalog.cod_unidade) || null,
            descricao_unidade: r.descricao_unidade || (fromCatalog && fromCatalog.descricao_unidade) || null,
            linhas_validadas: [],
            bestFences: [],
          };
          units.push(unit);
        }
        const distancia = r.distancia != null ? Number(r.distancia) : null;
        const prev = unit.linhas_validadas.find((l) => String(l.id_linha) === String(r.id_linha));
        const linha = {
          id_linha: r.id_linha,
          cod_linha: r.cod_linha,
          nome_linha: r.nome_linha,
          id_melhor_cerca: r.id_cerca,
          cod_cerca: r.cod_cerca,
          nome_cerca: r.nome_cerca,
          distancia,
          valido: Number(r.valido),
        };
        if (!prev) {
          unit.linhas_validadas.push(linha);
        } else if (
          prev.distancia == null
          || (distancia != null && distancia < prev.distancia)
        ) {
          Object.assign(prev, linha);
        }
      });
      Object.values(out).forEach((units) => units.forEach((u) => {
        u.linhas_validadas.sort((a, b) => {
          const da = a.distancia != null ? a.distancia : Number.POSITIVE_INFINITY;
          const db = b.distancia != null ? b.distancia : Number.POSITIVE_INFINITY;
          return da - db;
        });
      }));
      return out;
    },
    closePromoverDialog() {
      this.promoverDialog = false;
      this.grupoSelected = null;
      this.subgrupoSelected = null;
      this.situacaoSelected = null;
    },
    confirmPromover() {
      if (this.candidatosSelected.some((c) => !isValidado(c))) {
        this.messageConfirmButton = this.$t('button.confirm');
        this.messageDismissButton = this.$t('button.cancel');
        this.mensagemdialog = this.$t('candidate.confirmHire');
        this.confirmDialog = true;
      } else {
        this.promoverCandidatos();
      }
    },
    formatReservaDate(dt) {
      if (!dt) return '';
      const d = new Date(dt);
      if (isNaN(d.getTime())) return String(dt);
      return d.toLocaleString();
    },
    openReservaDialog() {
      if (this.candidatosSelected.length !== 1) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('candidate.validateNoSelection'),
        });
        return;
      }
      this.reservaCandidato = { ...this.candidatosSelected[0] };
      this.reservaDialog = true;
      this.loadReservaData();
    },
    resolveReservaPrefill(candidato) {
      if (!candidato) {
        return { id_linha: null, id_cerca: null };
      }
      let idLinha = candidato.id_melhor_linha || null;
      let idCerca = candidato.id_melhor_cerca || null;

      if (!idLinha || !idCerca) {
        let bestRank = -1;
        let bestTurno = null;
        for (const t of this.turnosForUnidade(candidato.id_unidade)) {
          const key = `valido_${t.cod_turno}`;
          if (!Object.prototype.hasOwnProperty.call(candidato, key)) continue;
          const rank = mapMarkerPriorityRank(candidato[key]);
          if (rank > bestRank) {
            bestRank = rank;
            bestTurno = t;
          }
        }
        if (bestTurno) {
          const desc = bestTurno.descricao_turno;
          const codLinha = candidato[`cod_linha_${desc}`];
          const codCerca = candidato[`cod_cerca_${desc}`];
          if (!idLinha && codLinha && codLinha !== '-') {
            const linha = (this.reservaLinhas || []).find(
              (l) => String(l.cod_linha) === String(codLinha)
            );
            idLinha = linha ? linha.id_linha : null;
          }
          if (!idCerca && codCerca && codCerca !== '-') {
            const cercas = (this.reservaCercas || []).filter(
              (c) => !idLinha || String(c.id_linha) === String(idLinha)
            );
            const cerca = cercas.find((c) => String(c.cod_cerca) === String(codCerca));
            idCerca = cerca ? cerca.id_cerca : null;
          }
        }
      }

      return { id_linha: idLinha, id_cerca: idCerca };
    },
    applyReservaPrefill() {
      if (!this.reservaCandidato || this.reservaAtiva) return;
      const prefill = this.resolveReservaPrefill(this.reservaCandidato);
      this._reservaPrefilling = true;
      this.reservaLinhaSelected = prefill.id_linha;
      this.reservaCercaSelected = prefill.id_cerca;
      this.$nextTick(() => {
        this._reservaPrefilling = false;
      });
    },
    closeReservaDialog() {
      this.reservaDialog = false;
      this.reservaConfirmPending = false;
      this.reservaCandidato = null;
      this.reservaAtiva = null;
      this.reservaLinhas = [];
      this.reservaCercas = [];
      this.reservaLinhaSelected = null;
      this.reservaTurnoSelected = null;
      this.reservaCercaSelected = null;
      this._reservaPrefilling = false;
    },
    loadReservaData() {
      if (!this.reservaCandidato || !this.reservaCandidato.id_pessoa) return;
      const candidato = this.reservaCandidato;
      apiController.request(apiController.endpoints.getReservaativacandidato, {
        params: { id_pessoa: candidato.id_pessoa },
        onSuccess: (response) => {
          this.reservaAtiva = response.data.reserva || null;
        },
      });

      if (!candidato.id_unidade) return;

      (async () => {
        try {
          const [linhasRes, cercasRes] = await Promise.all([
            apiController.request(apiController.endpoints.getLinhasassociadas, { data: [candidato.id_unidade], silent: true }),
            apiController.request(apiController.endpoints.getCercasvalidacaocandidato, { params: { id: candidato.id_unidade }, silent: true }),
          ]);
          this.reservaLinhas = linhasRes.data || [];
          this.reservaCercas = cercasRes.data || [];
          this.applyReservaPrefill();
        } catch (e) {
          EventBus.$emit('show-error', { error: e });
        }
      })();
    },
    onReservaLinhaChange() {
      if (this._reservaPrefilling) return;
      this.reservaCercaSelected = null;
    },
    maxAssentosDisponiveisRow(row) {
      let max = 0;
      for (const dia of RESERVA_DIAS) {
        const v = Number(row['assentos_disponiveis_' + dia]);
        if (!isNaN(v) && v > max) {
          max = v;
        }
      }
      return max;
    },
    openReservaNoCapacityConfirm() {
      this.mensagemdialog = this.$t('candidateReservations.dialog.confirmNoCapacity');
      this.showConfirmButton = true;
      this.reservaConfirmPending = true;
      this.confirmDialog = true;
    },
    lineTurnoHasVaga() {
      if (!this.reservaLinhaSelected || !this.reservaTurnoSelected) {
        return null;
      }
      const rows = (this.reservaCercas || []).filter(
        (row) =>
          String(row.id_linha) === String(this.reservaLinhaSelected) &&
          String(row.id_turno_linha) === String(this.reservaTurnoSelected)
      );
      if (!rows.length) {
        return null;
      }
      return rows.some((row) => this.maxAssentosDisponiveisRow(row) > 0);
    },
    criarReserva(ignorarCapacidade = false) {
      if (!this.canCreateReserva) return;
      const hasVaga = this.lineTurnoHasVaga();
      if (hasVaga !== true) {
        this.openReservaNoCapacityConfirm();
        return;
      }
      const payload = {
        id_pessoa: this.reservaCandidato.id_pessoa,
        id_linha: this.reservaLinhaSelected,
        id_turno: this.reservaTurnoSelected,
        id_cerca: this.reservaCercaSelected,
        id_unidade: this.reservaCandidato.id_unidade,
        ignorarCapacidade: ignorarCapacidade,
      };
      apiController.request(apiController.endpoints.insertReservacandidato, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          if (response.data.erro) {
            this.reservaConfirmPending = true;
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' });
            this.loadReservaData();
          }
        },
        onError: (e) => {
          this.reservaConfirmPending = true;
          EventBus.$emit('show-alert', { mensagem: e.response.data.mensagem, tipo: 'error' });
        },
      });
    },
    cancelarReservaAtiva() {
      if (!this.reservaAtiva || !this.reservaAtiva.id_reserva) return;
      apiController.request(apiController.endpoints.cancelarreservacandidato, {
        data: { id_reserva: this.reservaAtiva.id_reserva },
        onSuccess: (response) => {
          if (response.data.erro) {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'success' });
            this.reservaAtiva = null;
          }
        },
      });
    },
    async promoverCandidatos() {
      this.resultadosAxios = [];
      let candidatos = this.candidatosSelected.map((c) => {
        c.contratado = 1;
        c.id_grupo = this.subgrupoSelected || this.grupoSelected;
        c.id_turno = this.turnoSelected;
        return c;
      });

      await Promise.all(candidatos.map((c) => this.atualizaSituacao(c.id_pessoa, this.situacaoSelected)));
      try {
        await Promise.all(
          candidatos.map(async (candidato) => {
            try {
              const response = await apiController.request(apiController.endpoints.updatePessoa, {
                data: candidato,
                silent: true,
              });
              this.resultadosAxios.push(response.data);
            } catch (e) {
              EventBus.$emit('show-error', { error: e });
            }
          })
        );
        this.resultadosAxios.push({ erro: false, mensagem: this.$t('candidate.hiringSuccess') });
        this.updateTable();
      } catch (e) {
        console.log(e);
        this.resultadosAxios.push({ erro: true, mensagem: this.$t('candidate.hiringError') });
        this.updateTable();
      }
    },

  },
};
</script>

<style scoped>
/* Barra com o botão que abre o menu de navegação da tela. */
.candidatos-topbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.candidatos-topbar__toggle {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.62) !important;
}
.candidatos-topbar__heading {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.candidatos-topbar__eyebrow {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  line-height: 1.2;
  text-transform: uppercase;
}
.candidatos-topbar__title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Menu de navegação: mesmo padrão visual do drawer da Roteirização. */
.candidatos-nav-drawer {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: min(340px, calc(100vw - 24px)) !important;
  z-index: 1200 !important;
  background: #fff !important;
}
.candidatos-nav-drawer ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.candidatos-nav-header {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 14px;
  min-height: 112px;
  padding: 24px 16px 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}
.candidatos-nav-brand-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border-radius: 4px;
}
.candidatos-nav-heading {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}
.candidatos-nav-eyebrow {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  line-height: 1.2;
  text-transform: uppercase;
}
.candidatos-nav-title {
  margin-top: 3px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.candidatos-nav-close {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.54) !important;
}
.candidatos-nav-list {
  padding: 0 !important;
  background: transparent !important;
}
.candidatos-nav-item {
  min-height: 48px;
  margin-bottom: 6px;
  border-radius: 4px !important;
  color: rgba(0, 0, 0, 0.72) !important;
  transition: background-color 0.18s ease, color 0.18s ease;
}
.candidatos-nav-item:hover {
  background: rgba(0, 0, 0, 0.04) !important;
}
.candidatos-nav-item--active {
  background: rgba(0, 0, 0, 0.08) !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600;
}
.candidatos-nav-item ::v-deep .v-list-item__icon {
  margin-right: 16px;
  color: inherit;
}
.candidatos-nav-active-mark.v-list-item__icon {
  min-width: auto;
  margin-right: 0;
  margin-left: 0;
}

/* Tabelas à esquerda, mapa à direita. */
.candidatos-split {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.candidatos-split__main {
  flex: 1 1 0;
  /* Sem isto a tabela larga estica o flex item e empurra o mapa para fora da tela. */
  min-width: 0;
}
.candidatos-split__side {
  flex: 0 0 clamp(320px, 30%, 460px);
  position: sticky;
  top: 88px;
  min-width: 0;
}
.candidatos-map-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 120px);
}
.candidatos-map-card__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
}
.candidatos-map {
  height: clamp(320px, 52vh, 620px);
  width: 100%;
  border-radius: 8px;
  z-index: 0;
}
@media (max-width: 1263px) {
  /* Abaixo de lg a tabela não cabe ao lado do mapa: empilha, mapa embaixo. */
  .candidatos-split {
    flex-direction: column;
  }
  .candidatos-split__main,
  .candidatos-split__side {
    flex: 1 1 auto;
    width: 100%;
  }
  .candidatos-split__side {
    position: static;
  }
  .candidatos-map-card {
    max-height: none;
  }
}
.candidatos-map-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.candidatos-map-legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}
.candidatos-map-popup {
  line-height: 1.35;
  max-width: 240px;
}
.unidade-validada-table ::v-deep td {
  vertical-align: top;
}
.allocation-trip-card {
  min-width: 250px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
}
.allocation-trip-card--ida {
  border-left: 4px solid #1976d2;
}
.allocation-trip-card--volta {
  border-left: 4px solid #673ab7;
}
.allocation-trip-card__title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}
</style>

<!-- Leaflet divIcon root is not a Vue element; override default leaflet-div-icon frame -->
<style>
.leaflet-container .candidatos-map-divicon {
  background: transparent !important;
  border: none !important;
}
</style>